'use strict';
/**
 * @param srvUF - server User Fields {Array}
 * @param billingInfoObj - app._upoList[id].billingDetails;
 * @returns {Array}
 */
app.extendUserPmFields = app.extendUserPmFields || (function (srvUF, billingInfoObj) {
	var retArr = $.extend(true, [], srvUF);
	if (billingInfoObj) {
		var keys = _.keys(billingInfoObj);
		_.each(keys, function (k) {
			if (billingInfoObj[k]) {
				var idx = _.findIndex(retArr, {"name" : k});
				if (idx < 0) {
					retArr.push({"name" : k, "value" : billingInfoObj[k]})
				} else {
					retArr[idx].value = billingInfoObj[k];
				}
			}
		});
	}
	return retArr;
});

app.populateSrvUserFields = app.populateSrvUserFields || (function (userFields) {
	if (_.isArray(userFields)) {
		_.each(userFields, function (elm) {
			_setElmValue(elm.value, elm.name);
		});
	} else {
		_.each(userFields, _setElmValue);
	}

	/***************  populateSrvUserFields helpers Start  *************/
	function _setElmValue(value, fldName) {
		if (fldName && value) {
			var $elm = $("#" + fldName);
			$elm.val(value);
			if ($elm.attr('data-plugin') === 'cSelect') {
				$elm.change();
			}
		}
	}

	/***************  populateSrvUserFields helpers End  *************/
});

var customFieldsForValidation = [];
app.addCustomValidationFields = function (fieldsForValidation) {
	_.each(fieldsForValidation, function (field) {
		if(_.findIndex(customFieldsForValidation, function (o){ return o === field;}) === -1){
			customFieldsForValidation.push(field);
		}
		app.util.attachFieldValidation(field);
	});
};

app.clearCustomValidationFields = function () {
	customFieldsForValidation = [];
};

app.reduceCustomValidationFieldsBy = function (fieldsArray) {
	_.each(fieldsArray ||[], function (field) {
		var idx = _.findIndex(customFieldsForValidation, function (o) {return o === field;});
		if ( idx > -1 ) {
			customFieldsForValidation.splice(idx, 1);
		}
	})
};

app.selectPM = function (uniqueId, allowApplePayAutoSelect, isManual) {
	isManual = isManual || false;
	if (uniqueId) {
		pubsub.publish('dr-select-pm', [{
			uniqueId     : uniqueId,
			type         : (isNaN(parseInt(uniqueId, 10)) ? 'string' : 'int'),
			skipFldClear : true,
			allowApplePayAutoSelect: allowApplePayAutoSelect,
			manual       : isManual
		}]);
		return;
	}
	if ($('[data-pms-type="vertical"]').length || $('[data-pms-type="horizontal"]').length || $('[data-pms-type="table"]').length || $('[data-pms-type="dropdown"] select').length) {
		app._flag.setDefaultMethodId = true;
	}
	pubsub.publish('dr-select-pm', [{uniqueId : 'auto_select', type : 'auto_select', skipFldClear : true, manual: isManual}]);
};

var getCurrentCardType = function (returnFullData, useDataWrapper) {
	var cc_type = 'none';
	var retObj = {master_brand : 'none'};
	var cc_card_id = app.util.getPmSpecificFldName('cc_card_number', app.lastSelectedMethodType);
	var $cardNumberElm = app.util.$getPmSpecificElement('cc_card_number', app.lastSelectedMethodType);
	var cardNumber = $cardNumberElm.length ? $cardNumberElm.val().replace(/ /g, '') : '';
	if (cardNumber) {
		var cardInfo = app.util.asyncCheck.getCardInfo(cardNumber);
		retObj = cardInfo ? _extractCardInfo(cardInfo) : _checkCardType(cardNumber);
		if (cardInfo && app.lastCardDetected !== 'none' && (cardInfo.cardBrand === app.lastCardDetected || cardInfo.cardBrand2 === app.lastCardDetected)) {
			cc_type = app.lastCardDetected;
		} else {
			cc_type = retObj.master_brand;
		}
	} else if (app.currentMethodFields && app.currentMethodFields[cc_card_id] && app.currentMethodFields[cc_card_id].card_type) {
		var cardData  = app.util.extractCardInfo(app.currentMethodFields[cc_card_id].card_type, app.currentMethodFields._cardData);
		cc_type = cardData.selectedBrand;
		retObj = cardData.cardInfo;
	}

	if (cc_type === 'amex' || cc_type === 'none' || cc_type === 'astropay_card') {
		app.util.setCVVLength({card_type : cc_type});
	}
	return useDataWrapper ? {selectedBrand: cc_type, cardInfo: retObj} : (returnFullData ? retObj : cc_type);

	function _extractCardInfo(_cardInfo) {
		_cardInfo = _cardInfo || {};
		var server_class = _cardInfo.cardBrand || 'none';
		if (_cardInfo.isDualBrand) {
			if (_cardInfo.cardBrand === app.lastCardDetected) {
				server_class = _cardInfo.cardBrand + '_' + _cardInfo.cardBrand2
			}
			else if (_cardInfo.cardBrand2 === app.lastCardDetected) {
				server_class = _cardInfo.cardBrand2 + '_' + _cardInfo.cardBrand;
			}
		}
		return {
			full_class      : server_class + (_cardInfo.isDualBrand ? "_dual" : ""),
			server_class    : server_class,
			master_brand    : _cardInfo.cardBrand,
			slave_brand     : _cardInfo.cardBrand2,
			is_dual_brand	: _cardInfo.isDualBrand
		};
	}
};

app.state = {};
app.synchCounter = 0;
app.synchTableReload = false;

app.openedInIframeMode = function inIframe() { // renamed, so not to b? confused with inIframeMode
	try {
		return window.self !== window.top;
	} catch (e) {
		return true;
	}
}();

app.showModalMessage = function (data, type, onConfirm, onCancel, className, modalWrapper, onModalShows) {
	type || (type = 'unknown');
	className || (className = '');
	var classList = type + " " + className;
	if (app.util.shouldSkipLightbox(type)) {
		$.unblockUI();
		return;
	}

	if(modalWrapper !== 'lightbox_ws') {
		$('[role="lbx_wrapper"]').empty().removeClass();
	}

	var modalWrapperId = modalWrapper || app.config.modalsConfig.customWrapperId[type];
	var lightBoxElm = modalWrapperId && $("#" + modalWrapperId);
	if (modalWrapperId && lightBoxElm && lightBoxElm.length) {
		if(modalWrapper !== 'lightbox_ws') {
			lightBoxElm.attr('role', "lbx_wrapper");
		}
		lightBoxElm.html(app.config.modalsConfig.mainTemplate);
	} else {
		modalWrapperId = 'lightbox';
		lightBoxElm = $('#lightbox');
	}

	var contentTemplate;
	if (type === app.CONSTANTS.MODAL_MESSAGE_TYPE.SUCCESS && app.config.show_extended_success_lightbox) {
		contentTemplate = app.util.getLightboxContentTemplate(app.CONSTANTS.MODAL_MESSAGE_TYPE.EXTENDED_SUCCESS);
		classList += " extended_success";
	} else {
		contentTemplate = app.util.getLightboxContentTemplate(type);
		if (type === app.CONSTANTS.MODAL_MESSAGE_TYPE.SUCCESS) {
			classList += " default_success";
		}
	}
	var payload = $.extend({message: data.details || data.message}, {type: type});
	lightBoxElm.removeClass().addClass(classList);
	$('.lightbox-header', lightBoxElm).html(app.util.getLightboxTitleTemplate(type)(payload));
	$('.lightbox-content', lightBoxElm).html(contentTemplate(payload));

	$.unblockUI();
	app.util.transformLightboxContent(lightBoxElm, payload);

	if (modalWrapperId === 'lightbox') {
		app.modalLink.trigger('click');
	} else if (modalWrapperId === 'lightbox_ws') {
		app.modalLink_3.trigger('click');
	} else { // we have custom wrapper (not a modal)
		lightBoxElm.find('.modal_close').on('click', _safeFn(_closePseudoLbx));
	}
	lightBoxElm.find('.on_confirm').on('click', _safeFn(onConfirm));
	lightBoxElm.find('.on_cancel').on('click', _safeFn(onCancel));
	(onModalShows && _.isFunction(onModalShows) && onModalShows());

	pubsub.publish('lightbox.opened', [{type: type, isWs: (modalWrapper === 'lightbox_ws')}]);

	/***************  showModalMessage helpers Start  *************/
	function _safeFn(fn) {
		return function (e) {
			e && e.stopPropagation();
			var elm = this;
			(fn || _.identity).call(elm, e);
			return false;
		}
	}

	function _closePseudoLbx(e) {
		lightBoxElm.empty();
		app.onNotificationEnd();
	}

	/***************  showModalMessage helpers End  *************/
};

app.showFinalMessage = function (message) {
	app.showModalMessage({message: message}, 'error_fatal');
};
// TBD: Do we need this Fn?
app.onBackToPaymentMethodsList = function () {
	window.history.back();
};

app.onUserPaymentOptionAvailable = function (data) {
	var def = new $.Deferred();
	var hasGooglePay = false, googleScriptIsReady = true;
	var hasApplePay = false, appleScriptIsReady = true;
	var checkExpiryDate = function(yyyymmdd){
		var year = parseInt(yyyymmdd.substring(0,4), 10);
		var month = parseInt(yyyymmdd.substring(4,6), 10 ) -1 ;
		var day = parseInt(yyyymmdd.substring(6,8), 10);
		return (new Date()) > (new Date(year, month, day))
	};
	data = _.map(data,  function(item){
		if ((!item.blockers || _.isEmpty(item.blockers)) && item.expiryDate && item.paymentOptionName === 'visa_checkout' && checkExpiryDate(item.expiryDate)){
			item.blockers = {
				accountVerificationStatusBlocker : app.msg.visa_checkout_expired
			}
		}
		if (item.paymentOptionName === app.CONSTANTS.PM_NAME.GOOGLE_PAY) {
			hasGooglePay = true;
			googleScriptIsReady = false;
		} else if (item.paymentOptionName === 'ppp_ApplePay') {
			hasApplePay = true;
		} else if (item.paymentOptionName === app.CONSTANTS.PM_NAME.PAY_WITH_MY_BANK) {
			item = utils.pwmb.formatSrvData(item, item.name);
		} else if (item.paymentOptionName === app.CONSTANTS.PM_NAME.BLIK) {
			if (item.name) {
				item.multilineData = {
					tooltip: app._t("blik_without_code", [app._t(app.CONSTANTS.PM_NAME.BLIK)]) + "\n" + app._t("from_bank", [item.name]),
					title: app._t("blik_without_code", [app._t(app.CONSTANTS.PM_NAME.BLIK)]),
					subtitle: app._t("from_bank", [item.name]),
					mobileTitle: app._t("blik_without_code", [""])
				};
			}
		} else if (item.paymentOptionName === app.CONSTANTS.PM_NAME.TRUSTLY_DI) {
			if (item.name) {
				var accountNumberRegex = /.*([0-9a-z]{4})$/i;
				var trustlyBankName = item.name.split('-|-')[0];
				var trustlyAccountNumber = item.name.split('-|-')[1] || '';
				var shortMaskedAccountNumber = trustlyAccountNumber.replace(accountNumberRegex, '•$1');
				var longMaskedAccountNumber = trustlyAccountNumber.replace(accountNumberRegex, '••••$1');

				item.multilineData = {
					tooltip: trustlyBankName + "\n" + longMaskedAccountNumber,
					title: trustlyBankName,
					subtitle: longMaskedAccountNumber,
					mobileTitle: shortMaskedAccountNumber
				};
			}
		} else if (item.paymentOptionName === app.CONSTANTS.PM_NAME.CREDIT_CARD || item.paymentOptionName === app.CONSTANTS.PM_NAME.DEBIT_CARD) {
			if (app.config.useBancontactOneClick && item.oneClickPaymentSelectorLastValue) {
				item.additionalClass = "bancontactOneClickAvailable";
			}
		}
		return item;
	});
	app._userPmAvailableData = $.extend(true, [], data);
	app._upoList = {};

	if (hasApplePay) {
		var appleCfg = app.config.pmSettings.ppp_ApplePay;
		if (app.openedInIframeMode) {
			appleScriptIsReady = false;
			app._connectorPromise.onComplete(function () {
				appleScriptIsReady = true;
				_whenReadyProcessUpoData();
			});
		} else if (appleCfg && appleCfg.useApplePaySdk && appleCfg.appleSdkPromise) {
			appleScriptIsReady = false;
			appleCfg.appleSdkPromise.always(function (res) {
				appleScriptIsReady = true;
				_whenReadyProcessUpoData();
			});
		}
	}
	if (hasGooglePay) {
		googleScriptIsReady = false;
		app.util.GooglePay.init(app.config.pmSettings[app.CONSTANTS.PM_NAME.GOOGLE_PAY])
			.then(function (obj) {
				googleScriptIsReady = true;
				_whenReadyProcessUpoData();
			});
	}

	_whenReadyProcessUpoData();

	return def.promise();

	/***************  onUserPaymentOptionAvailable helpers Start  *************/

	function _whenReadyProcessUpoData() {
		if (appleScriptIsReady && googleScriptIsReady) {
			appleScriptIsReady = googleScriptIsReady = false;
			var filteredUpmData = _filterUpoData(data);
			app._filteredUpmData = filteredUpmData;
			pubsub.publish('user-pm-available', [filteredUpmData]);
			def.resolve(filteredUpmData);
		}
	}
	function _filterUpoData(_data) {
		var _filteredData = [], addMe;
		_.each(_data, function (upo) {
			if (upo.paymentOptionName === app.CONSTANTS.PM_NAME.GOOGLE_PAY) {
				addMe = app.util.GooglePay.isReadyToPay();
			} else if (upo.paymentOptionName === 'ppp_ApplePay') {
				addMe = app.util.isApplePayEnabled();
			} else {
				addMe = 1;
			}
			if (addMe) {
				_filteredData.push(upo);
				app._upoList[upo.userPaymentOptionId] = upo;
			}
		});
		return _filteredData;
	}

	/***************  onUserPaymentOptionAvailable helpers End  *************/
};

app.onPaymentOptionsAvailable = function (data) {
	var def = new $.Deferred();
	app._pmAvailableData = $.extend(true, [], data);
	var hasGooglePay = false, googleScriptIsReady = true;
	var hasApplePay = false, appleScriptIsReady = true;
	var pm_data = [];

	_.each(data, function (item) {
		var key = item.type || item.value;
		if (key) {
			app._poList[key] = $.extend(true, {}, item);
			if (app.customPMLimits) {
				if (app.customPMLimits[key]) {
					app.pmLimits[key] = $.extend(true, {}, item, app.customPMLimits[key]);
				} else {
					app.pmLimits[key] = $.extend(true, {}, item, app.customPMLimits['default'] || item);
				}
			} else {
				app.pmLimits[key] = item;
			}
			if(item.value === 'ppp_ApplePay'){
				hasApplePay = true;
			} else if (item.value === app.CONSTANTS.PM_NAME.GOOGLE_PAY) {
				hasGooglePay = true;
				googleScriptIsReady = false;
			}
			pm_data.push(item);
			return app.pmLimits[key];
		}
	});

	if (hasApplePay) {
		var appleCfg = app.config.pmSettings.ppp_ApplePay;
		if (app.openedInIframeMode) {
			appleScriptIsReady = false;
			app._connectorPromise.onComplete(function () {
				appleScriptIsReady = true;
				_whenReadyProcessPmData();
			});
		} else if (appleCfg && appleCfg.useApplePaySdk && appleCfg.appleSdkPromise) {
			appleScriptIsReady = false;
			appleCfg.appleSdkPromise.always(function (res) {
				appleScriptIsReady = true;
				_whenReadyProcessPmData();
			});
		}
	}
	if (hasGooglePay) {
		app.util.GooglePay.init(app.config.pmSettings[app.CONSTANTS.PM_NAME.GOOGLE_PAY])
			.then(function (obj) {
				googleScriptIsReady = true;
				_whenReadyProcessPmData();
			});
	}
	_whenReadyProcessPmData();

	return def.promise();

	/***************  onPaymentOptionsAvailable helpers Start  *************/

	function _whenReadyProcessPmData() {
		if (appleScriptIsReady && googleScriptIsReady) {
			appleScriptIsReady = googleScriptIsReady = false;
			var filteredPmData = app.util.filterPmData(pm_data);
			pubsub.publish('pm-available', [filteredPmData]);
			def.resolve(filteredPmData);
		}
	}

	/***************  onPaymentOptionsAvailable helpers End  *************/
};

app.applyTooltipPlugin = function () {
	var $elms = $('[data-plugin="tooltip"]');
	if ($elms.length) {
		_.each($elms, function (elm) {
			var tooltipElm = $(elm);
			tooltipElm.attr('title', app.msg[tooltipElm.data('message')]);
			if (tooltipElm && tooltipElm.tooltipster) {
				tooltipElm.tooltipster({
					position : ( tooltipElm.data('position') || 'top' ),//'bottom',//'left',//'right',
					speed    : 500
				});
			}
		});
	}
};

app.applycSelectPlugin = function () {
	var elm = $('select[data-plugin="cSelect"]');
	if (elm.length) {
		elm.cSelect();
	}
};

app.updateUIWithPoData = function (element, data) {
	app.current_pm_feeObj = data.fee;
	_preRender(data);
	pubsub.publish('pre-pm-render', [data]);

	$('#payment_method').val(data.value || element.name);

	var fld_maxlength = {
		echeck_account_number   : 12,
		echeck_aba_number       : 8,
		echeck_ssn              : 4,
		blik_code               : 6,
		moneta_payment_password : 5,
		toditocash_pin_code     : 5,
		nettelerSecureId        : 6,
		webanq_password         : 32
	};
	var transformer = app.transformPM || _.identity;
	var renderData = app._pmFields[data.value] || transformer({}, data.value);
	var html = '';

	if (data && data.attributes && data.attributes.poStatus === 'SUSPENDED') {
		$('.is-suspended').addClass('hidden');
		html = app.util.getSuspendedPmHtml(renderData);
		$('.PMINFO').html(html);
		app.util.addSuspendedPmBlocker(app.lastSelectedMethodId, !!html);
		app.currentMethodFields = renderData || {};
		app.util.onPMSelectedHandleBodyClasses(true);
	}
	else {
		$('.is-suspended').removeClass('hidden');
		if(data._extraData){
			renderData = data._extraData;
			html = utils.getExtraDetailsHtml(data._extraData, data);
		} else if (renderData) {
			_.each(_.keys(renderData), function (fieldName) {
				renderData[fieldName].value = app.config.user[fieldName] || renderData[fieldName].value || '';
				if ((renderData[fieldName].type === "HIDDEN" && !fieldName.endsWith("cc_exp_month"))
					|| fieldName.endsWith("cc_exp_year")) {
					return;
				}
				var payload = _.clone(fieldName.endsWith("cc_exp_month") ? renderData : renderData[fieldName]);
				payload.prefix = fieldName.endsWith("cc_exp_month") ? fieldName.substring(0, fieldName.length - "cc_exp_month".length) : '';
				payload.maxlength = (fld_maxlength[fieldName] || 70);
				payload.normalizedData = _.clone(renderData);
				payload.dropDownOptions = app.util.getPoDropDownOptions(fieldName, data);
				var fldType = payload.dropDownOptions.length? 'select' : false;
				html += app.util.getPoFieldTemplate(fieldName, fldType)(payload);
			});
		}
		$('.PMINFO').html(html);

		// wrong place! => _postRender
		if (app.config.canScanQR && app.lastSelectedMethodType === "apmgw_Abon") {
			app.util.scanDetails.init('scanQR');
		} else if (app.config.canScanCard && (app.lastSelectedMethodType === 'dc_card' || app.lastSelectedMethodType === 'cc_card')) {
			app.util.scanDetails.init('scanCard');
		}

		app.currentMethodFields = app.util.fixExpPeriodFormat(renderData);
		app.util.doSomePmSpecificTask(app.lastSelectedMethodType);
		app.util.renderOtherDetails(null, app.util.getOtherDetails());
		_postRender(renderData);
		app.applycSelectPlugin();
		app.util.prePopulateFields(app.currentMethodFields, app.lastSelectedMethodType);
		utils.showDisableFieldValidationIcon(app.currentMethodFields, app.lastSelectedMethodType, false);
		setContinueButtonAction(element);
	}

	app.util.handleFee(data.fee);

	pubsub.publish('post-pm-render', [data]);
};

app.onPMSelected = function (element) {
	app.util.onPMSelectedClearState();

	if (!element || !element.rawData) {
		return;
	}
	var getCurrenciesPromise;
	var uniqueId = element.uniqueId;
	var data = $.extend(true, {}, element.rawData);
	var isUPM = _.has(data, 'userPaymentOptionId');
	app.lastSelectedMethodId = element.uniqueId;
	app.lastSelectedMethodType = (isUPM) ? data.paymentOptionName : data.value;

	app.util.onPMSelectedHandleBodyClasses();
	app.util.onPMSelectedHandleUseSubpagesFlags(element.uniqueId);

	if (app.customPMLimits && (_.has(app.customPMLimits, app.lastSelectedMethodType) || _.has(app.customPMLimits, 'default'))) {
		data = $.extend(true, data, app.customPMLimits[app.lastSelectedMethodType] || app.customPMLimits['default']);
	}

	if (app.useCurrencyExchange) {
		if (app.ptRequestId && !app.config.useDcc) {
			var currencies = (isUPM) ? app._upoList[app.lastSelectedMethodId].currencies : data.currencies;
			var preferredCurrency = (isUPM) ? app._upoList[app.lastSelectedMethodId].preferredCurrency : data.preferredCurrency;
			app.util.currencyExchange.renderIMS(currencies, preferredCurrency);
		} else {
			getCurrenciesPromise = app.util.getCurrenciesPromise({
				upoId			: ((isUPM) ? app.lastSelectedMethodId : ''),
				selPaymentMethod: ((isUPM) ? '' : app.lastSelectedMethodId),
				detectedCardType: ''
			});
		}
	}

	data.pmPosition = element.pmPosition;
	app.lastSelectedMethodData = data;
    app.util.handleCardTypeCheck(data, 'select_pm');
	if (!isUPM) {
		app.util.getPmExtraDetails(app.lastSelectedMethodType, null, data, element)
			.then(_handleNonPtCurrencyExchange);
	} else if (isUPM) {
		app.util.getUpmDetails(data.userPaymentOptionId, data, element)
			.then(_handleNonPtCurrencyExchange);
	}

	/***************  onPMSelected helpers Start  *************/
	function _handleNonPtCurrencyExchange() {
		if (getCurrenciesPromise && uniqueId === app.lastSelectedMethodId) {
			getCurrenciesPromise.then(function (cArr) {
				app.renderCurrencyExchange(cArr, (isUPM && uniqueId));
				if (isUPM && app.config.useDcc && app.lastCardDetected === "master_card") {
					$('.dcc_container .agree_dcc_hint').addClass('dcc_hint_mc').text(app.msg.agree_dcc_hint_mc);
				}
			});
		}
	}

	/***************  onPMSelected helpers End  *************/
};

app.loadPMs = function () {
	var showMerchantPMs = app.showMerchantPM && !app.quickDeposit.isShow;
	app.util.retrievePaymentMethods(app.showUserPMs, showMerchantPMs);
};

app.reloadPMs = function () {
	var showMerchantPMs = app.showMerchantPM && !app.quickDeposit.isShow;
	if (app.config.ptRequestId) {
		$.getJSON('clearCacheItem.do', {item : 1, ssid : app.config.ssid}).done(function () {
			app.util.retrievePaymentMethods(app.showUserPMs, showMerchantPMs);
		});
	}
	else {
		app.util.retrievePaymentMethods(app.showUserPMs, showMerchantPMs);
	}
};

app.reloadUPMs = function () {
	if (app.config.ptRequestId) {
		$.getJSON('clearCacheItem.do', {item : 1, ssid : app.config.ssid}).done(function () {
			app.util.retrievePaymentMethods(app.showUserPMs, false);
		});
	}
	else {
		app.util.retrievePaymentMethods(app.showUserPMs, false);
	}
};

app.recalcUserDetailsArea = function (scrollToElement, doNotScroll) {
	setTimeout(function () {
		app.util.applyScrollablePlugin();
		if (app.scroller && app.scroller.refresh) {
			scrollToElement ? app.scroller.scrollToElement(scrollToElement, 200) : (doNotScroll ? '' : app.scroller.scrollTo(0, 0, 0));
		}
	}, 80);
};

app.onRemoveUPM = function (data) {
	if(!app.util.isDeletable(data.id)){
		console.warn("deletable : FALSE");
		return;
	}
	var _isRequestSent = false;
	var storedUpoData = app._upoList[data.id] || {};
	var message = {
		upmType      : (data.userPaymentMethodName || '').toLowerCase(),
		id           : data.id,
		name         : storedUpoData.name,
		cc_exp_month : '',
		cc_exp_year  : ''
	};
	if (app.util.isCardPM(data)) {
		var asterisk = app.config.asteriskTemplate || app.msg.asterisk_template || "*";
		message.upmType = data.card_type ? data.card_type.toLowerCase() : message.upmType;
		message.name = (data.cc_card_number && data.cc_card_number.value) ? asterisk + data.cc_card_number.value.substr(-4) : asterisk + message.name.replace(/[{()}]/g, '');
		if (data.cc_exp_month && data.cc_exp_year) {
			message.cc_exp_month = data.cc_exp_month.value;
			message.cc_exp_year = data.cc_exp_year.value;
		} else if (storedUpoData.cardExpiryDate) {
			var token = storedUpoData.cardExpiryDate.split('-');
			message.cc_exp_year = token[0].substr(-2);
			message.cc_exp_month = token[1];
		}
	}
	message.upmType += utils.getCustomImgClassNameSuffix(storedUpoData.metadata, data.id);
	pubsub.publish('app.event.removeUpoClicked', [{id: data.id, pmType: data.userPaymentMethodName}]);

	app.showModalMessage({message: message}, app.CONSTANTS.MODAL_MESSAGE_TYPE.CONFIRM_UPO_REMOVAL, _onConfirmRemoveUpo, _onCancelRemoveUpo);

	/***************  RemoveUPM helpers Start  *************/
	function _onConfirmRemoveUpo() {
		pubsub.publish('app.event.removeUpoConfirm', [{upoId: data.id, action: 'remove', pmName: data.userPaymentMethodName}]);
		if (!_isRequestSent) { /* prevent multiple "Yes" clicks */
			_isRequestSent = true;
			app.util.closeLightbox();
			$.blockUI();
			$.ajax({
				url: 'deleteUpo.do',
				data: {
					upoId: data.id,
					ssid: app.ssid
				},
				dataType: 'json'
			}).then(function (ajaxData) {
				if (ajaxData.allowAddNewUPO && !app.showMerchantPM) {
					app.util.modifyConfigParam('showMerchantPM', true);
				}
				if (ajaxData.status === "FAIL") {
					app.util.onRemoveUpoError(ajaxData, message);
				} else {
					app.util.onRemoveUpoSuccess(ajaxData, message);
				}
			}).fail(function () {
				app.showFinalMessage("general_error_text");
			}).always(function () {
				$.unblockUI();
			});
		}
	}

	function _onCancelRemoveUpo() {
		pubsub.publish('app.event.removeUpoCancel', [{upoId: data.id, action: 'cancel', pmName: data.userPaymentMethodName}]);
	}

	/***************  RemoveUPM helpers End  *************/
};

app.onNotificationEnd = function () {
	$('#lightbox').find('.lightbox-content').empty();
	app.onModalClose('synch');
};

app.relayEvents = function () {
	var _lastSentStartedDepositID;
	app.sendContentHeight_re = function() {
		var isInIframe = function () {
			try {
				return window.self !== window.top;
			} catch (e) {
				return true;
			}
		}();
		if (isInIframe){
			if (typeof app._domModificationHandler === 'function') {
				app._domModificationHandler();
			} else {
				var height = $('body').outerHeight(true);
				var parent_url = $('#parent_url').val() || '*';
				if (parent_url.trim() !== '') {
					parent.postMessage(JSON.stringify({action: 'resizeHeight', payload: height}), parent_url);
				}
			}
		}
	}

	var bfPostMessage = function (msg, method) {
		var parent_url = $('#parent_url').val() || '*';
		var pmName = method ? method : app.lastSelectedMethodType;
		msg.cd3 = 'payments - ' + pmName;
        if (app.config.muid) { msg.merchant_unique_id = app.config.muid; }
		var fullMsg = {
			action  : 'analytics',
			payload : msg
		};
		if (parent_url.trim() !== '') {
			parent.postMessage(JSON.stringify(fullMsg), parent_url);
		}
	};
	pubsub.subscribe('app.event.amountNotInRange', function (field,limit,eventType) {
		if (eventType === 'blur') {
			bfPostMessage({
				'action' : 'field error',
				'label'  : 'amount ' + limit + ' operator limit'
			});
		}
	});
	pubsub.subscribe('suggest-point-selected', function (data) {
		bfPostMessage({
			'action': 'suggested amount',
			'label': 'suggested amount value ' + data['selectedValue'],
			'selected_value' : data['selectedValue']
		});
	});
	pubsub.subscribe('app.event.directFlowCheckbox.change', function (data) {
		bfPostMessage({
			'action': 'directFlowCheckboxChange',
			'label': data['field'] + ' checkbox has been changed',
			'checkbox_state': data['isChecked'] ? 'on' : 'off'
		});
	});
	pubsub.subscribe('app.event.fieldBlurFail', function (field, errKey, eventType) {
		if (eventType === 'blur'  || (eventType === 'change' && field.startsWith("expiration_period")) ) {
			bfPostMessage({
				'action' : 'field error',
				'label'  : field + 'error - ' + errKey
			});
		}
	});
	pubsub.subscribe('app.event.fieldBlurSuccess', function (field, eventType) {
		if (eventType === 'blur' || (eventType === 'change' && field.startsWith("expiration_period")) ) {
			bfPostMessage({
				'action' : 'field complete',
				'label'  : field + ' complete'
			});
		}
	});

	pubsub.subscribe('app.event.DepositClicked', function () {
		bfPostMessage({
			'action'         : 'attempted ' + app.bfDepositDepositType + 'deposit',
			'label'          : app.lastSelectedMethodType,
			'deposit_amount' : $("#item_amount_1").val(),
			'currency'       : app.currency
		});
	});
	pubsub.subscribe('app.event.depositSuccess', function (method, currency, value, reference, info) {
		var msg = {
			'action'         : 'made ' + app.bfDepositDepositType + 'deposit',
			'label'          : method,
			'deposit_amount' : value,
			'currency'       : currency,
			'reference'      : reference
		};
		if (info && info.pa_trx && info.pa_trx.amount) {
			msg.partially_approved_amount = info.pa_trx.amount;
		}
		bfPostMessage(msg, method);
	});
	pubsub.subscribe('app.event.depositPending', function (method, currency, value) {
		bfPostMessage({
			'action'         : 'pending ' + app.bfDepositDepositType + 'deposit',
			'label'          : method,
			'deposit_amount' : value,
			'currency'       : currency
		}, method);
	});
	pubsub.subscribe('app.event.depositFailure', function (method, currency, value, reference, info) {
		bfPostMessage({
			'action'         : 'failed  ' + app.bfDepositDepositType + 'deposit',
			'label'          : method,
			'deposit_amount' : value,
			'currency'       : currency,
			'reason'		 : info.gwReason ? info.gwReason : ''
		}, method);
	});

	pubsub.subscribe('app.event.PMDataAvailable', function (upm) {
		_lastSentStartedDepositID = '';
		if (app.config.isSubsequentDepositor || upm.length) {
			app.bfDepositDepositType = '';
		} else {
			app.bfDepositDepositType = 'first ';
		}
	});
	pubsub.subscribe('post-pm-render', function () {
		app.sendContentHeight_re();
		bfPostMessage({
			'action' : 'saw',
			'label'  : 'payments iframe - ' + app.lastSelectedMethodType
		});
		$('body').one('click', function (e) {
			if(_lastSentStartedDepositID !== app.lastSelectedMethodId) {
				_lastSentStartedDepositID = app.lastSelectedMethodId;
				bfPostMessage({
					'action': 'started ' + app.bfDepositDepositType + 'deposit',
					'label': 'safecharge'
				});
			}
		});
	});

	pubsub.subscribe('post-upm-render', function () {
		app.sendContentHeight_re();
		bfPostMessage({
			'action' : 'saw',
			'label'  : 'payments iframe - ' + app.lastSelectedMethodType
		});
		$('body').one('click', function (e) {
			if(_lastSentStartedDepositID !== app.lastSelectedMethodId) {
				_lastSentStartedDepositID = app.lastSelectedMethodId;
				bfPostMessage({
					'action': 'started ' + app.bfDepositDepositType + 'deposit',
					'label': 'safecharge'
				});
			}
		});
	});

	pubsub.subscribe('app.event.drContactSupport', function (data) {

		var messageData = {},
			currentPM = app._upoList[app.lastSelectedMethodId] || app._poList[app.lastSelectedMethodId] || _.find(app._poList, {'value': app.lastSelectedMethodId});

		if(!currentPM) {
            return;
        }

		messageData['action'] =  'contactSupport';

		messageData.payload = {};

		messageData.payload['label'] = currentPM.paymentOptionName || currentPM.value;
		if(currentPM.isLastUsedAccount !== undefined) {
			messageData.payload['method_status'] = currentPM.isLastUsedAccount === true ? 'Active' : 'InActive';
		}
		if(currentPM.verificationStatus) {
			messageData.payload['verification_status'] = currentPM.verificationStatus;
		}
		if($('#currency_lbl').text().length) {
			messageData.payload['currency'] = app.lastSelectedCurrency;
		}
		if($('#item_amount_1').val().length) {
			messageData.payload['amount'] = $('#item_amount_1').val();
		}

		app.util.sendPostMessage(messageData, app.config.parentUrl);
	});

	pubsub.subscribe('app.event.registerFailure' , function () {
		app.util.sendPostMessage({
			"action" : "failedRegistration",
			"payload":{
				"label": app.lastSelectedMethodType
			}
		}, app.config.parentUrl);
	});

	pubsub.subscribe('app.event.successRegistration' , function () {
		app.util.sendPostMessage({
			"action" : "successfulRegistration",
			"payload":{
				"label": app.lastSelectedMethodType,
				"verification_status": 'New'
			}
		}, app.config.parentUrl);
	});

	pubsub.subscribe('app.event.wdCancelSuccess', function (data) {
		if (data && data.wdRequest) {
			app.util.sendPostMessage(utils.getCancelWdrPostMessageData("successfulCancelWithdrawal", data, app._wdList.withdrawalRequests, app._upoList), app.config.parentUrl);
		}
	});

	pubsub.subscribe('app.event.cc_card_number_pasted', function () {
		app.util.sendPostMessage({
			"action"  : "cc_pasted",
			"payload" : {
				"payment_method" : app.lastSelectedMethodType
			}
		}, app.config.parentUrl);
	});
};

app.analytics = (function ($, pubsub, _, window) {
	var NA = {};
	NA.CONST = {
		MULTIPLIERS: [1, 10, 100, 1000, 10000, 100000],
		EXTRA_MULTIPLIER: 10,
		EPSILON: 0.000001, /** Floating-point error correction */
		FAKE_ENV: "localhost",
		STATUS: {
			NOT_LOADED: 0,
			LOAD_IN_PROGRESS: 1,
			LOAD_SUCCESS: 2
		},
		EVENT_NAME: {
			AMOUNT_TYPED: 'User Typed Amount',
			AMOUNT_SUGGESTED: 'CE - Suggested amount',
			CHANGE_PM: 'Change payment method',
			CHANGE_CURRENCY: 'Currency Conversion',
			DR_ACTION: 'Decline Recovery Chosen',
			PAGE_LOAD: 'Loading cashier success',
			SUBMIT_FAILURE: 'Submit Failure',
			SUBMIT_SUCCESS: 'Successful Submit',
			TRX_PENDING: 'Pending Transaction',
			TRX_APPROVED: 'Approved Transaction',
			TRX_DECLINED: 'Declined Transaction',

			TRX_PA_CONFIRMED: 'Partial Approval Confirmed',
			TRX_PA_DECLINED: 'Partial Approval Rejected',

			PA_USER_CHOISE: 'Partial Approval Submitted',

			SCAN_CARD_BTN_CLICKED: 'Scan Button Clicked',
			SCAN_CARD_USED: 'Scan Button Used',

			CANCEL_PENDING_WD: 'Cancel Pending Withdrawal',
			UPO_REMOVAL_CLICKED: 'UPO Removal Clicked',
			UPO_REMOVAL_CHOSEN: 'UPO Removal Chosen',
			DISPLAY_BRAND_SELECTION: 'Display brand selection',
			CHANGE_BRAND: 'User Change Brand Deposit',
			POST_DEPOSIT_POPUP: 'User click on post deposit pop up'
		}
	};
	NA._g = {
		flag: {
			dataReadySentOnce: false
		},
		last: {
			changed_amount: false,
			keyup_amount: false,
			sent_amount: false,
			sent_currency: false,
			submit_info: {},
			select_pm_info: {},
			pa_choice_info: {},
			trx_complete_info: {},
			card_recognition_data: {}
		},
		iframe: false,
		isReady: 0,
		isLoadEvtSent: 0,
		evtQueue: [],
		iframeStatus: NA.CONST.STATUS.NOT_LOADED,
		ifameOrigin: document.location.origin
	};
	NA.cfg = {
		env: "production",
		url: "/cdn/v1/amplitude.html",
		default_url: "https://cdn-int.safecharge.com/safecharge_resources/v1/amplitude.html",
		ratesToUSD: {
			"USD": 1
		}
	};

	NA._logError = function (str) {
		if (str) {
			var msg = 'Analytics ERROR! => ' + str;
			app._logger.log(msg);
			console.error(msg);
			return true;
		}
	};
	NA._convertAmount = function _convertAmount(amount, rate, precision) {
		var multiplier, converted_amount = amount;
		if (amount) {
			precision = _.isNumber(precision) && precision >= 0 && precision < 5 ? precision : 2;
			rate = parseFloat(rate);
			rate = (rate === 0) ? 0 : (rate || 1);
			multiplier = NA.CONST.MULTIPLIERS[precision];
			converted_amount = Math.round(parseInt(amount * (rate * (multiplier * NA.CONST.EXTRA_MULTIPLIER)) + NA.CONST.EPSILON) / NA.CONST.EXTRA_MULTIPLIER) / multiplier;
		}
		return converted_amount;
	};
	NA._calcAmountInUSD = function (amount, currency) {
		return NA._convertAmount(amount, NA.cfg.ratesToUSD[currency || app.lastSelectedCurrency], 2);
	};
	NA._loadIframe = function () {
		var deferred = new $.Deferred();
		if (NA._g.iframe) {
			deferred.resolve(NA._g.iframe);
		} else {
			$(window).on('load', function () {
				var myOrigin = document.location.origin;
				var baseUrl = (NA.cfg.env === "production" || NA.cfg.env === "integration") ? app.config.templateResourcesPath + NA.cfg.url : NA.cfg.default_url;
				var src = (NA.cfg.env === NA.CONST.FAKE_ENV) ? "about:blank" : baseUrl + "?origin=" + encodeURIComponent(myOrigin);
				NA._g.ifameOrigin = (function () {var a = document.createElement("a");a.href = baseUrl;return a.origin;})();
				if (document.getElementById('amp_iframe')) {
					$('#amp_iframe').attr('src', src);
				} else {
					$(document.head).append('<iframe id="amp_iframe" src="' + src + '"></iframe>');
				}
				NA._g.iframe = document.getElementById('amp_iframe');
				deferred.resolve(NA._g.iframe);
			});
		}
		return deferred.promise();
	};
	NA._logEvent = function (data) {
		if (data) {
			if (data.event_type === NA.CONST.EVENT_NAME.PAGE_LOAD) {
				NA._g.evtQueue.unshift(data);
			} else {
				NA._g.evtQueue.push(data);
			}
			NA._execNext();
		}
	};
	NA._execNext = function () {
		if (NA._g.iframe && NA._g.isReady && NA._g.evtQueue[0] &&
			(NA._g.isLoadEvtSent || NA._g.evtQueue[0].event_type === NA.CONST.EVENT_NAME.PAGE_LOAD)
		) {
			NA._g.isLoadEvtSent = 1;
			var ev = NA._g.evtQueue.shift();
			if (NA.cfg.env === NA.CONST.FAKE_ENV) {
				console.log("EVENT >>", ev.event_type, ">> \n" + JSON.stringify(ev));
			} else {
				NA._g.iframe.contentWindow.postMessage(JSON.stringify(ev), NA._g.ifameOrigin);
			}
			NA._execNext();
		}
	};
	NA._onMessage = function (event) {
		var origin = event.originalEvent.origin;
		var data = event.originalEvent.data;
		if (origin === NA._g.ifameOrigin && data === 'AMP Ready') {
			NA._onIframeReady();
		}
	};
	NA._onIframeReady = function () {
		NA._g.isReady = true;
		NA._g.iframeStatus = NA.CONST.STATUS.LOAD_SUCCESS;
		NA._execNext();
	};
	NA._addEvtHeaders = function (event) {
		if (event) {
			event.channel = "amplitude";
			event.user_id = (NA.cfg.msid + '.' + NA.cfg.userId);
			event.timestamp = (new Date()).getTime();
			event.session_id = app.config.ssid;
		}
		return event;
	};
	NA._addUserInfo = function (event) {
		event || (event = {});
		event.user_properties = {
			site_id: NA.cfg.msid,
			country: app.config.country,
			client_id: NA.cfg.clientId,
			environment: NA.cfg.env,
			merchant_id: NA.cfg.mid,
			merchant_name: NA.cfg.merchantName,
			merchant_site: NA.cfg.siteName,
			is_pt_merchant: !!app.config.ptRequestId,
			multi_client_id: NA.cfg.multiClientId,
			user_session_id: app.config.ssid
		};
		return event;
	};
	NA._addPmInfo = function (event_props, pmName, isUpo, position) {
		position || (position = {});
		event_props || (event_props = {});
		event_props.pm = pmName;
		event_props.is_upo = isUpo;
		event_props.absolute_position = position.absolute;
		event_props.relative_position = position.relative;
		return event_props;
	};
	NA._addPmInfoWithFlowAndCardBrand = function (event_props, data) {
		event_props = NA._addPmInfo(event_props, data.pmName, data.isUpo, data.pmPosition);
		event_props.pm_flow = ($('#inIframeMode').val() === "true" ? "Direct" : "Redirect"); //// TBD -> is OK?;
		event_props.card_brand = (data.card_detected !== 'none') && data.card_detected;
		event_props.order_id = NA.cfg.orderId;
		event_props.upo_id = data.isUpo ? data.id : 'None';
		event_props.card_account_type = 'None';

		if (app.util.isCardPM(data.pmName)) {
			if (data.isUpo && app._upoList[data.id] && app._upoList[data.id].analyticsCardType) {
				event_props.card_account_type = app._upoList[data.id].analyticsCardType;
			} else if (!data.isUpo &&
				NA._g.last.card_recognition_data &&
				NA._g.last.card_recognition_data.cardType &&
				NA._g.last.card_recognition_data.partialCardNumber === NA.getPartialCardNumber()
			) {
				if (NA._g.last.card_recognition_data.prepaid) {
					event_props.card_account_type = "Prepaid";
				} else if (NA._g.last.card_recognition_data.cardType === "Credit" || NA._g.last.card_recognition_data.cardType === "Debit") {
					event_props.card_account_type = NA._g.last.card_recognition_data.cardType;
				}
			}
		}

		return event_props;
	};
	NA._extractPmNames = function (pmArr, type) {
		var key = type === 'pm' ? 'value' : 'paymentOptionName';
		var ret = _.reduce(pmArr, function (result, item) {
			result.push(item[key]);
			return result;
		}, [])
		return ret;
	};
	NA._getPageLoadData = function (upm, pm) {
		var exchange_type = !app.config.useCurrencyExchange ? "Disabled" : app.config.useDcc ? "DCC" : app.config.ptRequestId ? "Playtech" : "Regular";
		var allowPromoCode = false;
		_.each(window.srvOtherFields, function(fieldData) {
			if(fieldData && fieldData.name === "promoCode") {
				allowPromoCode = true;
			}
		});
		if (!allowPromoCode && app.config.showPromoCode) {
			_.each(window.srvPmFields, function(fieldData) {
				if(fieldData && fieldData.name === "promoCode") {
					allowPromoCode = true;
				}
			});
		}
		var allowedInstallmentPrograms = [];
		if (app.config.installmentConfig && app.config.installmentConfig.isActive) {
			for (var i = 0; i < app.config.installmentConfig.programs.length; i++) {
				allowedInstallmentPrograms.push(app.config.installmentConfig.programs[i].text);
			}
		}
		var event_props = {
			pms: NA._extractPmNames(pm, 'pm'),
			upos: NA._extractPmNames(upm, 'upm'),
			order_id: NA.cfg.orderId,
			language: app.config.locale,
			skip_cvv: NA.cfg.skipCVV,
			first_pm: (pm && pm[0] && pm[0].value || "None"),
			first_upo: (upm && upm[0] && upm[0].paymentOptionName || "None"),
			first_pm_type: (pm && pm[0] && pm[0].apmGwType || "None"),
			first_upo_pm_type: (upm && upm[0] && upm[0].apmGwType || "None"),
			is_native: app.config.isNative === true ? 1 : (app.config.isNative || 0),
			is_open_amount: !!app.config.isOpenAmount,
			is_quick_deposit: NA.cfg.isQuickDeposit,
			allow_installments: NA.cfg.allowInstallments,
			allow_installments_programs: NA.cfg.allowInstallmentsPrograms,
			allowed_installment_program_types: allowedInstallmentPrograms,
			allow_decline_recovery: NA.cfg.allowDeclineRecovery,
			allow_partial_approval: NA.cfg.allowPartialApproval,
			allow_suggested_amounts: NA.cfg.allowSuggestedAmounts,
			currency_conversion: exchange_type,
			allow_scancard: app.config.canScanCard,
			allow_websocket: !!app.config.ws_server,
			allow_subscription: app.config.isRebilling,
			verification_flow: NA.cfg.verification_flow,
			account_updater: NA.cfg.account_updater,
			allow_delete_UPOs: app.config.allowDeleteUPO,
			allow_promo_code: allowPromoCode,
			use_3ds_v2: app.config.use3dsv2,
			allow_dual_brand: app.config.useDualCardBrands,
			allow_bancontact_one_click: app.config.useBancontactOneClick,
			allow_click_to_pay: !!(app.config.pmSettings.c2p && app.config.pmSettings.c2p.enabled),
			made_successful_deposit: NA.cfg.made_successful_deposit,
			device_type_nuvei: utils.getNuveiDeviceTypeForAnalytics(),
			theme: app.config.themeName || 'None',
			theme_id: app.config.tid || 'None'
		};
		if (NA.cfg.skipCVV) {
			event_props.skip_cvv_per_scheme = NA.cfg.skipCVVPerScheme;
			event_props.skip_cvv_per_device = NA.cfg.noCvvPerDevice;
		}
		return event_props;
	};
	NA._sendEventWithAmount = function (event_type, amount, currency, event_props, includeUserInfo) {
		currency || (currency = app.lastSelectedCurrency);
		event_props || (event_props = {});
		event_props.amount = amount;
		event_props.currency = currency;
		event_props.usd_amount = NA._calcAmountInUSD(amount, currency);
		event_props.$price = event_props.usd_amount;
		var evt = {
			event_type: event_type,
			event_properties: event_props
		};
		NA._logEvent(NA._addEvtHeaders(includeUserInfo ? NA._addUserInfo(evt) : evt));
		NA._g.last.sent_amount = amount;
		NA._g.last.sent_currency = currency;
		return event_props;
	};
	NA._getTrxCompleteEventName = function (trxStatus, isPartialChoiceConfirmation) {
		var event_type;
		if (trxStatus) {
			if (isPartialChoiceConfirmation) {
				event_type = trxStatus === 'APPROVED' ? NA.CONST.EVENT_NAME.TRX_PA_CONFIRMED : NA.CONST.EVENT_NAME.TRX_PA_DECLINED;
			} else {
				event_type = trxStatus === 'APPROVED' ? NA.CONST.EVENT_NAME.TRX_APPROVED : trxStatus === 'PENDING' ? NA.CONST.EVENT_NAME.TRX_PENDING : NA.CONST.EVENT_NAME.TRX_DECLINED;
			}
		}
		return event_type || NA.CONST.EVENT_NAME.TRX_DECLINED;
	};
	NA._composeTrxCompleteData = function (evtData, isPartialChoiceConfirmation) {
		var event_props,
			event_type = NA._getTrxCompleteEventName(evtData && evtData.trxStatus, isPartialChoiceConfirmation),
			data = evtData && (evtData.details || evtData),
			remapProps = {
				amount: 'amount',
				currency: 'currency',
				card_type: 'card_brand',
				reference: 'transaction_id',
				payment_method: 'pm'
			},
			cardAccountTypes = {
				"Debit": "Debit",
				"Credit": "Credit",
				"Prepaid": "Prepaid"
			};
		if (data) {
			var pm = evtData.payment_method || (evtData.details && evtData.details.payment_method) || (app.submittedMethod && app.submittedMethod.pmName) || app.lastSelectedMethodType;
			var last_submitted_pm = (NA._g.last.submit_info && NA._g.last.submit_info.pm);
			// TBD: (!pm || pm === last_submitted_pm) is it enough???
			event_props = (!pm || pm === last_submitted_pm) ? $.extend(true, {}, NA._g.last.submit_info) : {};
			_.each(data, function (value, key) {
				if (remapProps[key]) {
					event_props[remapProps[key]] = value;
				}
			});
			event_props.transaction_type = data.transaction_type || '';
			event_props.order_id = NA.cfg.orderId;
			event_props.issuer_bank = data.issuerBankName || false;
			event_props.notification_source = evtData.eventType === 'websocket' ? 'websocket' : 'synchronous';
			event_props.upo_id = event_props.upo_id || 'None';
			if (data.cardAccountType) {
				event_props.card_account_type = cardAccountTypes[data.cardAccountType] || "None";
			}
			if (data.amount && data.currency) {
				event_props.amount = data.amount;
				event_props.currency = data.currency;
				event_props.usd_amount = NA._calcAmountInUSD(data.amount, data.currency);
				event_props.$price = event_props.usd_amount;
			}
			if (event_type === NA.CONST.EVENT_NAME.TRX_APPROVED) {
				var is_partial = !_.isEmpty(data.pa_trx);
				event_props.is_partial = is_partial;
				event_props.approved_amount = is_partial ? data.pa_trx.amount : event_props.amount;
				event_props.approved_currency = is_partial ? data.pa_trx.currency : event_props.currency;
				event_props.approved_amount_usd = is_partial ? NA._calcAmountInUSD(data.pa_trx.amount, data.pa_trx.currency) : event_props.usd_amount;
				event_props.$price = event_props.approved_amount_usd;
			}
			else if (event_type === NA.CONST.EVENT_NAME.TRX_DECLINED) {
				event_props.error_code = data.errorCode || '';
				event_props.error_message = data.apmErrorMsg || data.userMessage || '';
				event_props.condition_type = data.softDecline ? 'soft_decline' : !_.isEmpty(data.depositConfirmations) ? 'user_notification' : 'none';
				event_props.is_conditional = event_props.condition_type !== 'none';
			}
		} else {
			event_props = {};
		}
		return {event_type: event_type, event_properties: event_props};
	};
	NA._sendTrxComplete = function (data) {
		if (data && app.util.isPartialChoiceConfirmation(data)) {
			// TBD: NA._logEvent(NA._addEvtHeaders(NA._g.last.pa_choice_info = NA._composeTrxCompleteData(data, true)));
		} else if (data) {
			NA._logEvent(NA._addEvtHeaders(NA._g.last.trx_complete_info = NA._composeTrxCompleteData(data, false)));
		}
	};
	NA._sendPaUserChoice = function (data) {
		var event;
		if (NA._g.last.trx_complete_info.event_properties && NA._g.last.trx_complete_info.event_properties.is_partial) {
			event = _.cloneDeep(NA._g.last.trx_complete_info);
		} else {
			event = {event_properties: {}};
		}
		event.event_type = NA.CONST.EVENT_NAME.PA_USER_CHOISE;
		event.event_properties.order_id = NA.cfg.orderId;
		event.event_properties.pa_user_choice = data.action === 'confirm' ? 'approved' : 'cancel';
		return event;
	};
	NA._sendDrAction = function (data) {
		if (data) {
			var canReuseStoredData = (NA._g.last.trx_complete_info && NA._g.last.trx_complete_info.event_type === NA.CONST.EVENT_NAME.TRX_DECLINED);
			var reference = (canReuseStoredData ? NA._g.last.trx_complete_info.event_properties['transaction_id'] : '');
			var error_message = (canReuseStoredData ? NA._g.last.trx_complete_info.event_properties['error_message'] : '');
			var pmType = (canReuseStoredData ? NA._g.last.trx_complete_info.event_properties['pm_type'] : 'None');
			var event_props = {
				"pm": data.paymentMethodDR || '',
				"pm_type": pmType,
				"order_id": NA.cfg.orderId,
				"transaction_id": reference,
				"selected_action": data.metaInfo ? data.metaInfo.actionType : '',
				"dr_option_position": data.metaInfo ? data.metaInfo.drOptionPosition : '',
				"error_message": error_message
			};
			NA._logEvent(NA._addEvtHeaders(NA._g.last.dr_info = {event_type: NA.CONST.EVENT_NAME.DR_ACTION, event_properties: event_props}));
		}
	};

	NA._sendCancelPendingWD = function(data) {
		var pendingWdObj = findPendingWd(data.buttonId);
		var pendingWd = pendingWdObj.request;
		var position = pendingWdObj.position;

		var event_props = {
			wd_request_id: pendingWd.wd_requestId,
			wd_pm: pendingWd.params && pendingWd.params.poName,
			card_brand: (pendingWd.params && pendingWd.params.card_type) || 'None',
			wd_absolute_position: position
		};

		if (app.config.ptRequestId) {
			event_props.upo_id = pendingWd.orders.length && pendingWd.orders[0].upoId ? pendingWd.orders[0].upoId : '';
		} else {
			event_props.upo_id = pendingWd.upo_id
		}

		var amount = pendingWd.requestedAmount;
		event_props.wd_amount = amount;
		event_props.wd_currency = pendingWd.requestedCurrency;
		event_props.wd_amount_usd = NA._calcAmountInUSD(amount, pendingWd.requestedCurrency);
		event_props.$price = event_props.wd_amount_usd;
		var evt = {
			event_type: NA.CONST.EVENT_NAME.CANCEL_PENDING_WD,
			event_properties: event_props
		};
		NA._logEvent(NA._addEvtHeaders(evt));
		function findPendingWd(reqId) {
			var position = 0;

			for (var i = 0; i < app._wdList.withdrawalRequests.length; i++) {
				if (app._wdList.withdrawalRequests[i].renderingState === 'CANCELABLE' && app._wdList.withdrawalRequests[i].status !== 'CANCELED') {
					position += 1;
				}
				if (app._wdList.withdrawalRequests[i].wd_requestId == reqId) {
					return {request: app._wdList.withdrawalRequests[i], position: position};
				}
			}
		}
	};

	NA._sendUpoRemovalChoice = function(data) {
		var event_props = {};
		event_props.order_id = NA.cfg.orderId;
		event_props.upo_id = data.upoId;
		event_props.pm = data.pmName;
		event_props.absolute_position = NA._g.last.select_pm_info.absolute_position || 1;
		event_props.selected_action = data.action;
		NA._sendEventWithAmount(NA.CONST.EVENT_NAME.UPO_REMOVAL_CHOSEN, app.lastSelectedAmount, null, event_props, true);
	};

	NA.saveLastCardRecognitionData = function(data) {
		NA._g.last.card_recognition_data = data.resp;
		NA._g.last.card_recognition_data.partialCardNumber = NA.getPartialCardNumber();
	};
	NA.getPartialCardNumber = function() {
		var cardNum = app.util.$getPmSpecificElement('cc_card_number', app.lastSelectedMethodType).val();
		return cardNum.substr(0, 1) + " " + cardNum.substr(cardNum.length - 4); // takes first and last 4 digits of the card num
	};
	NA._registerPubsubEvents = function () {
		pubsub.subscribe('app.event.PMDataAvailable', function (upm, pm) {
			if (!NA._g.flag.dataReadySentOnce) {
				NA._sendEventWithAmount(NA.CONST.EVENT_NAME.PAGE_LOAD, app.config.amount, app.config.currency, NA._getPageLoadData(upm, pm), true);
				NA._g.flag.dataReadySentOnce = true;
			}
		});
		pubsub.subscribe('select-pm', function (data, arg2, arg3, manual) {
			var event_props = {};
			if (NA._isTypedAmount(app.lastSelectedAmount)) {
				event_props.order_id = NA.cfg.orderId;
				NA._sendEventWithAmount(NA.CONST.EVENT_NAME.AMOUNT_TYPED, app.lastSelectedAmount, null, event_props);
			}
			if (_.isUndefined(manual) || manual) {
				var isUpo = app.util.isUpo(data.uniqueId);
				var pmName = (isUpo ? data.name : data.uniqueId);
				event_props = NA._addPmInfo({}, pmName, isUpo, data.pmPosition);
				event_props.pm_type = (isUpo ? (app._upoList[data.uniqueId] && app._upoList[data.uniqueId].apmGwType) : (app._poList[data.uniqueId] && app._poList[data.uniqueId].apmGwType)) || "None";
				event_props.order_id = NA.cfg.orderId;
				event_props.upo_id = isUpo ? data.uniqueId.toString() : 'None';
				NA._g.last.select_pm_info = NA._sendEventWithAmount(NA.CONST.EVENT_NAME.CHANGE_PM, app.lastSelectedAmount, null, event_props);
			}
		});
		pubsub.subscribe('app.event.dualBrandRadioBtnCreated', function (data) {
			var event_props = {
				primary_brand: data.cardBrand,
				secondary_brand: data.cardBrand2,
				selected_brand: data.selectedBrand,
				is_upo: data.isUpo
			};
			if (data.isUpo) {
				event_props.upo_id = data.uniqueId;
			}

			NA._logEvent(NA._addEvtHeaders({event_type: NA.CONST.EVENT_NAME.DISPLAY_BRAND_SELECTION, event_properties: event_props}));
		});
		if (app.config.useSubpages && !app.config.preventPMAutoSelect) {
			// This if for the initial method that is preselected on page load
			pubsub.subscribe('select-pm-attempt', function (data) {
				if (data && data.reason === "already_selected") {
					var lastSentPmId = NA._g.last.select_pm_info.is_upo ? NA._g.last.select_pm_info.upo_id : NA._g.last.select_pm_info.pm;
					if (!lastSentPmId || data.uniqueId != lastSentPmId) {
						var event_props = {};
						var isUpo = app.util.isUpo(data.uniqueId);
						event_props.absolute_position = "1",
						event_props.relative_position = "1",
						event_props.is_upo = isUpo;
						event_props.pm = isUpo ? app._upoList[data.uniqueId].paymentOptionName : data.uniqueId.toString();
						event_props.pm_type = (isUpo ? (app._upoList[data.uniqueId] && app._upoList[data.uniqueId].apmGwType) : (app._poList[data.uniqueId] && app._poList[data.uniqueId].apmGwType)) || "None";
						event_props.order_id = NA.cfg.orderId;
						event_props.upo_id = isUpo ? data.uniqueId.toString() : 'None';
						NA._g.last.select_pm_info = NA._sendEventWithAmount(NA.CONST.EVENT_NAME.CHANGE_PM, app.lastSelectedAmount, null,event_props);
					}
				}
			});
		}
		pubsub.subscribe('app.event.changeDualBrandedCardBrand', function(data) {
			var event_props = {
				selected_brand: data.selectedBrand,
				payment_method: data.pmType,
				upo_id: (data.isUpo ? data.uniqueId : null),
				is_upo: data.isUpo
			};
			NA._logEvent(NA._addEvtHeaders({event_type: NA.CONST.EVENT_NAME.CHANGE_BRAND, event_properties: event_props}));
		});
		pubsub.subscribe('submit-attempt-failed', function (data) {
			var event_props = NA._addPmInfoWithFlowAndCardBrand({}, data);
			event_props.pm_type = (data.isUpo ? (app._upoList[data.id] && app._upoList[data.id].apmGwType) : (app._poList[data.id] && app._poList[data.id].apmGwType) || "None");
			event_props.field_errors = (data.errors || []);
			NA._g.last.submit_info = NA._sendEventWithAmount(NA.CONST.EVENT_NAME.SUBMIT_FAILURE, app.lastSelectedAmount, null, event_props);
		});
		pubsub.subscribe('app.event.formSubmit', function (data) {
			var event_props = NA._addPmInfoWithFlowAndCardBrand({}, data);
			event_props.pm_type = (data.isUpo ? (app._upoList[data.id] && app._upoList[data.id].apmGwType) : (app._poList[data.id] && app._poList[data.id].apmGwType) || "None");
			var cvvElm = $('#cc_cvv2');
			event_props.with_cvv_input = (cvvElm.length !== 0 && cvvElm.val().trim() !== '');
			var $promoCode = $('#promoCode');
			event_props.with_promo_code = $promoCode.length !== 0 && !$promoCode.is(':disabled') && $promoCode.val().trim() !== '';
			var $installmentProgram = $('#installment_program');
			var $debitType = $('#debit_type');
			var installmentType = 'None';
			if (NA.cfg.allowInstallmentsPrograms && $installmentProgram.length) {
				for (var i = 0; i < app.config.installmentConfig.programs.length; i++) {
					if (app.config.installmentConfig.programs[i].value === $installmentProgram.val()) {
						installmentType = app.config.installmentConfig.programs[i].text;
						break;
					}
				}
			} else if (NA.cfg.allowInstallments && $debitType.length) {
				var DEBIT_TYPE = {
					'1' : 'REGULAR',
					'2' : 'PAYMENTS',
					'3' : 'SPECIAL'
				};
				installmentType = DEBIT_TYPE[$debitType.val()] || 'None';
			}
			event_props.installment_type = installmentType;
			var $numInstallments = $('#number_of_installments');
			if ((NA.cfg.allowInstallments || NA.cfg.allowInstallmentsPrograms) && $numInstallments.length) {
				event_props.number_of_installments = $numInstallments.val() || "1";
			}
			NA._g.last.submit_info = NA._sendEventWithAmount(NA.CONST.EVENT_NAME.SUBMIT_SUCCESS, app.lastSelectedAmount, null, event_props);
		});
		pubsub.subscribe('safecharge.transaction.complete', function (data) {
			NA._sendTrxComplete(data);
		});
		pubsub.subscribe('app.event.transactionComplete', function (data) {
			NA._sendTrxComplete(data);
		});
		pubsub.subscribe("app.event.paUserChoice", function (data) {
			NA._logEvent(NA._addEvtHeaders(NA._sendPaUserChoice(data)));
		});
		pubsub.subscribe('app.event.drContactSupport', function (data) {
			NA._sendDrAction(data);
		});
		pubsub.subscribe('app.event.drLowerOpenAmount', function (data) {
			NA._sendDrAction(data);
		});
		pubsub.subscribe('app.event.drSelectPm', function (data) {
			NA._sendDrAction(data);
		});
		pubsub.subscribe('app.event.drTryAgain', function (data) {
			NA._sendDrAction(data);
		});
		pubsub.subscribe('app.event.currencyChanged', function (data) {
			if (data && data.amount && data.currencyISO && data.currencyISO !== NA._g.last.sent_currency) {
				var isUpo = NA._g.last.select_pm_info.is_upo || app.util.isUpo(app.lastSelectedMethodId);
				var pmName = NA._g.last.select_pm_info.pm || app.lastSelectedMethodType;
				var event_props = NA._addPmInfo({}, pmName, isUpo, {});
				event_props.order_id = NA.cfg.orderId;
				NA._sendEventWithAmount(NA.CONST.EVENT_NAME.CHANGE_CURRENCY, data.amount, data.currencyISO, event_props);
				NA._g.last.keyup_amount = false;
				NA._g.last.changed_amount = data.amount;
			}
		});
		pubsub.subscribe('app.event.RestrictionsApplied', function (amount) {
			NA._g.last.changed_amount = amount;
		});
		pubsub.subscribe('app.event.AmountChange', function (amount, ev_type, tag_name) {
			var evtToTag = {blur: 'INPUT', change: 'SELECT'};
			if (amount && ev_type && evtToTag[ev_type] === tag_name) {
				if (ev_type === "change" || NA._isTypedAmount(amount)) {
					var event_props = {};
					event_props.order_id = NA.cfg.orderId;
					NA._sendEventWithAmount(NA.CONST.EVENT_NAME.AMOUNT_TYPED, amount, null, event_props);
					NA._g.last.keyup_amount = false;
				}
				NA._g.last.changed_amount = amount;
			} else if (ev_type === 'keyup' || ev_type === 'keypress' || ev_type === "maskedAmountUserInput") {
				NA._g.last.keyup_amount = amount;
			}
		});
		pubsub.subscribe('suggest-point-selected', function (data) {
			var event_props = {};
			event_props.order_id = NA.cfg.orderId;
			NA._sendEventWithAmount(NA.CONST.EVENT_NAME.AMOUNT_SUGGESTED, data['selectedValue'], null, event_props);
			NA._g.last.keyup_amount = false;
			NA._g.last.changed_amount = data['selectedValue'];
		});
		pubsub.subscribe('app.event.scanCardBtnClicked', function(data) {
			var event_props = {
				order_id: NA.cfg.orderId,
				scan_trigger: data && data.scanType === "scanQR" ? "qr_code" : "cc_card",
				pm: app.lastSelectedMethodType
			};
			NA._logEvent(NA._addEvtHeaders({event_type: NA.CONST.EVENT_NAME.SCAN_CARD_BTN_CLICKED, event_properties: event_props}));
		});
		pubsub.subscribe('app.event.scanedCard', function(scanCardData) {
			var event_props = {};
			event_props.order_id = NA.cfg.orderId;
			if (scanCardData.source === "scanCard") {
				event_props.card_number_scanned = !!scanCardData.cardNumber;
				event_props.expirationDate_scanned = !!scanCardData.expDate;
				event_props.holderName_scanned = !!scanCardData.cardHolderName;
				event_props.card_brand = scanCardData.cardNumber ? checkCardType(scanCardData.cardNumber) : 'None';
				event_props.qr_code_scanned = false;
			}
			else {
				event_props.card_number_scanned = false;
				event_props.expirationDate_scanned = false;
				event_props.holderName_scanned = false;
				event_props.card_brand = 'None';
				event_props.qr_code_scanned = !!scanCardData.qrCode;
			}
			NA._logEvent(NA._addEvtHeaders({event_type: NA.CONST.EVENT_NAME.SCAN_CARD_USED, event_properties: event_props}));
		});
		pubsub.subscribe('app.event.card_recognition_complete', NA.saveLastCardRecognitionData);
		pubsub.subscribe('withdraw-cancel-start', NA._sendCancelPendingWD);
		pubsub.subscribe('app.event.removeUpoClicked', function(data) {
			var event_props = {};
			event_props.order_id = NA.cfg.orderId;
			event_props.upo_id = data.id.toString();
			event_props.pm = data.pmType;
			event_props.absolute_position = NA._g.last.select_pm_info.upo_id === event_props.upo_id ? NA._g.last.select_pm_info.absolute_position : "1";
			NA._sendEventWithAmount(NA.CONST.EVENT_NAME.UPO_REMOVAL_CLICKED, app.lastSelectedAmount, null, event_props, true);
		});
		pubsub.subscribe('app.event.removeUpoConfirm', NA._sendUpoRemovalChoice);
		pubsub.subscribe('app.event.removeUpoCancel', NA._sendUpoRemovalChoice);
		pubsub.subscribe('lightbox.closed', function(data) {
			if (data && (data.type === 'success' || data.type === 'pending' || data.type === 'error' || data.type === 'error-suggest')) {
				NA._logEvent(NA._addEvtHeaders({event_type: NA.CONST.EVENT_NAME.POST_DEPOSIT_POPUP, event_properties: {popup_type: data.type}}));
			}
		});
	};
	NA._isTypedAmount = function (amount) {
		var _hasKeyupAmount = NA._g.last.keyup_amount || NA._g.last.keyup_amount !== false;
		/** type coercions is intentional */
		return (_hasKeyupAmount && NA._g.last.keyup_amount == amount && NA._g.last.keyup_amount != NA._g.last.changed_amount);
	};
	NA._hasInitError = function (config) {
		var errorMsg;
		if (NA._g.iframe || NA._g.iframeStatus) {
			errorMsg = 'Second Init!';
		} else if (!config) {
			errorMsg = 'Missing configuration!';
		} else if (!window.postMessage) {
			errorMsg = 'window.postMessage is undefined!!!';
		}
		return errorMsg && NA._logError(errorMsg);
	};
	NA.updateExchangeRates = function (rateObj) {
		if (!_.isEmpty(rateObj)) {
			NA.cfg.ratesToUSD = $.extend(true, NA.cfg.ratesToUSD, rateObj);
		}
	};
	NA.init = function _init(config) {
		if (NA._hasInitError(config)) {
			return;
		}
		NA._g.iframeStatus = NA.CONST.STATUS.LOAD_IN_PROGRESS;
		NA.cfg = $.extend(true, NA.cfg, config);
		$(window).on('message', NA._onMessage);
		NA._registerPubsubEvents();
		NA._loadIframe().then(function () {
			(NA.cfg.env === NA.CONST.FAKE_ENV && setTimeout(function () {
				console.log("ANALYTICS_FAKE_ENV READY");
				NA._onIframeReady();
			}, 1000));
			app._logger.log('Analytics INIT! => iframe created');
		});
	};

	return {
		init: NA.init,
		calcAmountInUSD: NA._calcAmountInUSD,
		updateUSDExchangeRates: NA.updateExchangeRates,
		sendEvent: function (event_type, event_properties) {
			if (app.config.useAnalytics && NA._g.iframeStatus && event_type && event_properties) {
				NA._logEvent(NA._addEvtHeaders({event_type: event_type, event_properties: event_properties}));
				return true;
			}
		}
	};
})(jQuery, pubsub, _, window);

app.onTrxSuccessHandler = function () {
	app.util.sendPostMessage(app.CONSTANTS.MODAL_MESSAGE_TYPE.SUCCESS, app.config.parentUrl);
	if (app.config.nextDepositURL) {
		app.util.updateCSRFToken(app.reloadPMs);
	} else {
		$.blockUI();
	}
}

app.onTransactionComplete = function (data) {
	if (data && data.softDecline) {
		submitForm(null, true);
		return;
	}
	var isWSEvent =  data && data.eventType === "websocket";
	var modalWrapper = isWSEvent ? "lightbox_ws" : "";
	var feRef = data && (data.feRef || (data.details && data.details.feRef ));
	var submittedData = (app.util.FeRef.isValid(feRef) && app.util.FeRef.getRefData(feRef) || app).submittedMethod || {};
	var pmName = (data && (data.payment_method || (data.details && data.details.payment_method))) || submittedData.pmName;
	var amount = data && _.has(data.details, 'amount') ? data.details.amount : (submittedData.amount || $("#item_amount_1").val());
	var trxCurrency = data && _.has(data.details, 'currency') ? data.details.currency : (submittedData.currency || app.currency);
	var trxId = data && ((data.ApmReference || data.reference) || data.details && (data.details.ApmReference || data.details.reference));
	var gwReason = data && (data.gwReason || data.details && data.details.gwReason);
	var metaInfo = {feRef: app.util.FeRef.isValid(feRef) && feRef, isWS: isWSEvent, gwReason: gwReason, source: 'onTransactionComplete'};

	if (data) {
		app.util.FeRef.isValid(feRef) && app.util.FeRef.setRefData(feRef, "trxResp" + (isWSEvent ? "Ws" : ""), data);
		if (!isWSEvent) {
			app.config.nextDepositURL = data.nextDepositURL;
		}
		if (data.source === "closeApmPopup") {
			app._flag.ommitPostSubmitCheck = true;
		}

		if (pmName && pmName === app._flag.lastApmOpenedInFrame) { // m/b we have to extend criteria
			app.util.closeTargetIframe();
		}
	}

	if (!isWSEvent) {
		if (app.lastSelectedMethodType === 'ppp_ApplePay') {
			app.util.ApplePayTrxStatus(data);
		}
		app.util.onTrxCompleteClearDOM();
	}

	if (data) {
		var isPMException = (!isWSEvent && app.lastSelectedMethodType === app.CONSTANTS.PM_NAME.STP_MEX);
		var normalizedData = data;
		if (app.config_transformTransactionEndData) {
			normalizedData = app.config_transformTransactionEndData(data, pmName);
		}
		if ("apmgw_Webmoney_SMS_Invoice_" === app.lastSelectedMethodType && !app._WM_flag && !isWSEvent) {
			handleWebMoney(app._WM_sms, data['trxStatus'], normalizedData, isPMException);
		}
		else if (data['trxStatus'] === app.CONSTANTS.TRX_STATUS.APPROVED && !isPMException) {
			app._WM_flag = false;
			app.submittedMethod = false;
			var eMetaInfo = $.extend(true, {
				isPartialChoiceConfirmation: app.util.isPartialChoiceConfirmation(normalizedData),
				pa_trx: normalizedData.details && normalizedData.details.pa_trx
			} , metaInfo);
			pubsub.publish('app.event.depositSuccess', [pmName, trxCurrency, amount, trxId, eMetaInfo]);
			var typeSuccess = app.CONSTANTS.MODAL_MESSAGE_TYPE.SUCCESS;
			var handlerSuccess;
			if (isWSEvent) {
				handlerSuccess = function() {
					app.util.sendPostMessage(typeSuccess, app.config.parentUrl);
					app.reloadPMs();
				}
			} else {
				handlerSuccess = app.onTrxSuccessHandler;
			}
			app.util.handleTrxCompletePopups(normalizedData, typeSuccess, handlerSuccess, handlerSuccess, false, '', modalWrapper);
		}
		else if (data['trxStatus'] === app.CONSTANTS.TRX_STATUS.PENDING && !isPMException) {
			app._WM_flag = false;
			app.submittedMethod = false;
			pubsub.publish('app.event.depositPending', [pmName, trxCurrency, amount, trxId, metaInfo]);
			var typePending = app.CONSTANTS.MODAL_MESSAGE_TYPE.PENDING;
			var handlerPending = function () {
				app.util.sendPostMessage(typePending, app.config.parentUrl);
				if (app.config.nextDepositURL) {
					app.util.updateCSRFToken(app.reloadPMs);
				} else {
					$.blockUI();
				}
			};
			app.util.handleTrxCompletePopups(normalizedData, typePending, handlerPending, handlerPending);
		}
		else {
			app._WM_flag = false;
			handleTrxStatusCancel(normalizedData, isPMException);
		}
	}

	/***************  onTransactionComplete helpers Start  *************/
	function onCancelHandler(showMsg) {
		$('#tmpDepositConfirmations').remove();
		pubsub.publish('app.event.depositFailure', [pmName, trxCurrency, amount, trxId, metaInfo]);
		var isWsUserCancelation = isWSEvent && normalizedData && normalizedData.details && normalizedData.details.userCancelation;
		var feRefData = app.util.FeRef.getRefData(metaInfo.feRef);
		if (!isWsUserCancelation && !feRefData.getNextStepDoCalled && !feRefData.trxErrorReloadPMsCalled) {
			app.util.FeRef.isValid(metaInfo.feRef) && app.util.FeRef.setRefData(metaInfo.feRef, "trxErrorReloadPMsCalled", 1);
			app.reloadPMs();
		}
		var type = app.CONSTANTS.MODAL_MESSAGE_TYPE.ERROR;
		var handler = function () {
			app.util.sendPostMessage(type, app.config.parentUrl);
		};
		if (showMsg && app.quickDeposit.isShow) {
			app.util.handleTrxCompletePopups(normalizedData, type, handler, handler, false, '', modalWrapper);
		} else if (showMsg) {
			var trxRef = normalizedData && (normalizedData.details && normalizedData.details.reference || normalizedData.reference); // ~ trxId
			if (!isWSEvent || app.config.useCsmsMessages) {
				app.showErrorDeclineRecoveryPopup(normalizedData.message || normalizedData, normalizedData.apmErrorMsg, trxRef, metaInfo);
			} else {
				app.util.handleTrxCompletePopups(normalizedData, type, handler, handler, false, '', modalWrapper);
			}
		} else {
			app.util.closeLightbox();
		}
	}

	function handleTrxStatusCancel(_normalizedData, _isPMException) {
		var proceed = true;
		if (_.has(_normalizedData, 'errorCode') && app.config_handleSrvResponseErrorCode) {
			proceed = app.config_handleSrvResponseErrorCode(_normalizedData);
		}
		if (proceed && _isPMException) {
			app.util.closeLightbox();
			if (!app.util.FeRef.getRefData(metaInfo.feRef).trxErrorReloadPMsCalled) {
				app.util.FeRef.isValid(metaInfo.feRef) && app.util.FeRef.setRefData(metaInfo.feRef, "trxErrorReloadPMsCalled", 1);
				app.reloadPMs();
			}
		} else if (proceed) {
			/** @namespace normalizedData.depositConfirmations */
			if (_normalizedData && _normalizedData.depositConfirmations) {
				var onConfirm = function () {
					app.util.addConfirmedUserActions(_normalizedData.depositConfirmations, _normalizedData.orderTransactionId);
					var cvvElm = $('#cc_cvv2');
					if (cvvElm.length && !cvvElm.val() && app._oldCVV) {
						cvvElm.val(app._oldCVV);
					}
					var silent = true;
					app.continueButtonHandler(null, silent);
				};
				app.util.showDepositConfirmations(_normalizedData.depositConfirmations, _normalizedData.orderTransactionId, onConfirm, onCancelHandler);
			} else {
				onCancelHandler(true);
			}
		}
	}

	function handleWebMoney(isSms, trxStatus, _normalizedData, _isPMException) {
		function _getNextStep() {
			app.util.closeLightbox();
			apmPopupClosedCallback();
		}
		if (trxStatus === app.CONSTANTS.TRX_STATUS.PENDING) {
			app._WM_flag = 1;
			if (isSms) {
				var sms_input_tpl = '<div class="row webmoney_sms_code_lightbox">' +
					'<input type="text" maxlength="64" id="webmoney_sms_code_lightbox"  placeholder="<%- t("webmoney_sms_code")%>">' +
					'<div id="webmoney_sms_code_lightbox_validation" class="validation_image "></div></div>';
				if ($('#fld_webmoney_sms_code_lightbox').length) {
					sms_input_tpl = $('#fld_webmoney_sms_code_lightbox').text();
				}
				app.showModalMessage({
						message : {
							titleKey : 'enter_your_code',
							text     : _.template(sms_input_tpl)(),
							btn_text : app.msg.webmoney_confirm_deposit_btn
						}
					},
					'webmoney_lightbox',
					function () {
						var lightBoxElm =  $('#lightbox');
						var val = lightBoxElm.find('input').val();
						if (val && (val = val.trim())) {
							if (app.util.validateField('webmoney_sms_code_lightbox', val, '', 'blur')) {
								app.util.makeWMFinishPaymentRequest(app.ssid, val, _getNextStep);
								lightBoxElm.hide();
							}
						}
					},
					_getNextStep
				);
				$('#webmoney_sms_code_lightbox').numberMask({type : 'int', beforePoint : 64, afterPoint : 0});
			} else {
				app.showModalMessage({
						message : {
							titleKey : 'webmoney_invoice_title',
							text     : app.msg.webmoney_invoice_info,
							btn_text : app.msg.webmoney_invoice_accepted_btn
						}
					},
					'webmoney_lightbox',
					function () {
						app.util.makeWMFinishPaymentRequest(app.ssid, null, _getNextStep);
						$('#lightbox').hide();
					},
					_getNextStep
				);
			}
		} else if (trxStatus === app.CONSTANTS.TRX_STATUS.APPROVED) {
			app._WM_flag = 1;
			_getNextStep();
		} else { // CANCEL
			app._WM_flag = false;
			handleTrxStatusCancel(_normalizedData, _isPMException);
		}
	}
	/***************  onTransactionComplete helpers End  *************/
};

app.createDefaultObjects = function() {
	app._autoGeneratedValidationRules = {};
	app._popupValidation = {};
	app._validationResult = {};
	app._isOptionalField = {};
	app._upoList = {};
	app._poList = {};
	app._flag = {skipUpoMessage: {}};
	app._countryStates = {};
	app.pmLimits = {};
	app.pluginOpts = app.pluginOpts || {};
	app.currentMethodFields = app.currentMethodFields || {};
	app.postponedTrxOnApmClose = [];

	app._pmFields = {};
	app._logger = app.util.getLogger();
	app._deviceType = utils.getUserAgentInfo().isMobile ? app.CONSTANTS.DEVICE_TYPE.MOBILE : app.CONSTANTS.DEVICE_TYPE.DESKTOP;
	app._connectorPromise = (function () {
		var _state = 'pending', _data = false, _onChange = [];
		function _exec(data) {
			_.each(_onChange, function (f) {
				if (_.isFunction(f)) {
					f(data);
				}
			});
		}
		return {
			complete            : function (data) {
				if (_state !== 'completed') {
					_state = 'completed';
					_data = data;
					_exec(data);
				}
			},
			getState              : function () {
				return _state;
			},
			onComplete : function (fn) {
				if (_state === 'completed') {
					if (_.isFunction(fn)) {
						fn(_data);
					}
				} else {
					_onChange.push(fn);
				}
			},
			getApplePaySupportObj : function () {
				var obj;
				if (_state === 'completed') {
					obj = $.extend(true, {}, _data, {state : _state, originalState : this.state()});
				}
				return obj;
			}
		};
	})();
};

app.initBlockUI = function (opt) {
	// FN initBlockUI( app.pluginOpts.blockUI )
	$.blockUI.defaults.message = app.msg['please_wait'];
	$.blockUI.defaults.onBlock = function () {
		var opts = {
			lines       : 13        // The number of lines to draw
			, length    : 28        // The length of each line
			, width     : 14        // The line thickness
			, radius    : 42        // The radius of the inner circle
			, scale     : 1         // Scales overall size of the spinner
			, corners   : 1         // Corner roundness (0..1)
			, color     : '#ec1f27' // #rgb or #rrggbb or array of colors
			, opacity   : 0.25      // Opacity of the lines
			, rotate    : 0         // The rotation offset
			, direction : 1         // 1: clockwise, -1: counterclockwise
			, speed     : 1         // Rounds per second
			, trail     : 60        // Afterglow percentage
			, fps       : 20        // Frames per second when using setTimeout() as a fallback for CSS
			, zIndex    : 2e9       // The z-index (defaults to 2000000000)
			, className : 'spinner' // The CSS class to assign to the spinner
			, top       : '50%'     // Top position relative to parent
			, left      : '50%'     // Left position relative to parent
			, shadow    : true      // Whether to render a shadow
			, hwaccel   : true      // Whether to use hardware acceleration
			, position  : 'absolute' // Element positioning
		};
		var target = $('h1').get(0);
		app.spinner = new Spinner(opts).spin(target);
	};
	$.blockUI.defaults.onUnblock = function () {
		console.log('STOPPING....');
		if (app.spinner) {
			app.spinner.stop();
		}
	};
	$.blockUI.defaults = $.extend(true, $.blockUI.defaults, opt);
};

app.attachWsLbContainer = function attachWsLbContainer() {
	if (!app.bodyElm.find('#lightbox_ws').length) {
		var lbContainer$ = $(app.config.modalsConfig.wsContainerTpl);
		app.bodyElm.append(lbContainer$);
	}
	if (!app.modalLink_3) {
		app.modalLink_3 = $('<a href="#' + 'lightbox_ws"></a>');
		app.modalLink_3.sModal({
			closeButton : "#lightbox_ws .modal_close",
			onClose     : function() {
					$('#lightbox_ws').hide().empty().removeClass();
					$("body").removeClass("overflowed_ws");
					app.onModalClose('ws');
			}
		});
	}
};

app.init_websocket_client = function(){
	if (app.config && app.config.ws_server) {
		app.util.Ws.init({
			ssid: app.config.ssid,
			wssUrl: app.config.ws_server + "/ws",
			appId: 'cashier',
			notificationRelevanceChecker: app.util.wsNotificationRelevanceChecker
		});
	}
};

app.init = function (cfg) {
	app.config.canScanQR = (document.location.hash.indexOf("scanQR") > -1);
	app.config.canScanCard = (document.location.hash.indexOf("scanCard") > -1);
	app.createDefaultObjects();
	app.bfDepositDepositType = '';
	app._parentSupportApplePay = false;
	app._currentMethodCurrencies = false;

	app.util.postMessageListener();
	app.formatter = app.util.getFormatter(cfg.useIntlFormatter);
	app._webViewSDK = (window.NuveiCashierHelper || window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.NuveiCashierHelper);
	app.util.asyncCheck = utils.getCardAsyncChecker(cfg.country, cfg.ssid, cfg.msid, "/ppp/checkCardDetails");
	if (cfg.remapCurrency && _.isFunction(cfg.remapCurrency)) {
		app.util.remapCurrency = cfg.remapCurrency;
	}
	var appleCfg = app.config.pmSettings.ppp_ApplePay;
	if (app.openedInIframeMode) {
		if (appleCfg && appleCfg.useApplePaySdk) {
			app._connectorPromise.isCrossBrowser = appleCfg.useApplePaySdk;
			app._connectorPromise.merchantIdentifier = appleCfg.applePayMerchantId;
			app._connectorPromise.applePayEnv = app.config.analyticsConfig.env !== 'production'? "sandbox" : "prod";
		}
		app.util.ApplePayConnector.connect(app._connectorPromise);
		app._connectorPromise.always(function (data) {
			app._parentSupportApplePay = data && data.parentSupportApplePay;
			app._parentApplePayMaxSupportedVersion = data && data.parentApplePayMaxSupportedVersion || 1;
			if (appleCfg && appleCfg.useApplePaySdk && appleCfg.applePayButtonScriptUrl && app._parentSupportApplePay) {
				$.getScript(appleCfg.applePayButtonScriptUrl, function(){/*console.log('AppleBtnReady');*/});
			}
			app.util.normalizeApplePayConfig(appleCfg);
			app._connectorPromise.complete(data);
		});
		app.config.useGpSdkProxy && app.util.GooglePay.checkForProxy();
	} else if (appleCfg && appleCfg.useApplePaySdk && appleCfg.applePaySdkUrl) {
		appleCfg.appleSdkPromise = app.util.getLoadScriptPromise(appleCfg.applePaySdkUrl, 3000)
			.always(function (res) {
				if (res && res.result && res.status === 'success') {
					app._flag.isAppleScriptReady = true;
				}
				app.util.normalizeApplePayConfig(appleCfg, app._flag.isAppleScriptReady);
				pubsub.publish('app.event.appleSdkReady', [res]);
				return res;
			});
	} else {
		app.util.normalizeApplePayConfig(appleCfg);
	}
	app.lastSelectedCurrency = app.lastSelectedCurrency || app.currency;
	app.lastSelectedAmount = (app.config.isOpenAmount && app.config.voicePaymentsAmount) || app.lastSelectedAmount || app.amount;
	window['srvPmFields'] = app.util.filterCitadelFields(window['srvPmFields'], app.country);
	window['srvPmFields'] = app.util.filterDirectFlowFields(window['srvPmFields']);

	var t = function (key, args) {
		if (key == undefined) {
			console.error('Invalid Tran key:', key);
			return '';
		}
		var transKey = key;
		var obj = {};
		_.each(args, function (v, i) {
			obj['{' + i + '}'] = v;
		});
		if (key.indexOf("ptadapter.ims.error.") === 0) {
			transKey = 'ims_err_' + key.substring(20);
		}
		if (_.has(app.msg, transKey)) {
			transKey = app.msg[transKey];
		} else if(app.config.showMissingTranslationKeys){
			console.warn('Tran key', key, 'is missing');
		}
		transKey = transKey.replace(/(\{\d\})/g, function (text) {
			return obj[text] != undefined ? obj[text] : '';
		});
		return transKey;
	};
	_.templateSettings.imports = {t : t, c : app.formatter};
	app._t = t;

	utils.getCountries().then(function (countries) {
		app.countries = countries;
	});

	app.util.getCountryStates('CA').then(function (states) {
		app._countryStates["CA"] = states;
	});
	app._pmFields = app.util.getPMFields(window['srvPmFields']);

	app.initBlockUI(app.pluginOpts.blockUI);
	app.util.injectDefaultCss();

	if (app.config.useAnalytics) {
		app.analytics.init(app.config.analyticsConfig);
	}
	if (app.config.relayAnalyticsEvents) {
		app.relayEvents(app.config);
	}
	/** EXTEND SESSION */
	if (app.config.sessionExpirationMinutes) {
		app.util.extendSession(app.config.sessionExpirationMinutes);
	}
	utils.showVersionOnAltVTwice();
	utils.showQROnAltQTwice();
	utils.getPhoneCodes();
	utils.handlePassiveEvents();
	utils.startSessionTimer();
	utils.initDevPmPickerLazyLoader();

	$(document).ajaxSuccess(utils.restartSessionTimer);

	pubsub.subscribe('app.event.formSubmit', utils.restartSessionTimer);

	app.util.loadMainLayout();
	app.bodyElm = $('body');
	app.util.FeRef.init(app.lastTrxData && app.lastTrxData.feRef);
	if (!app.bodyElm.find('#lightbox').length) {
		app.bodyElm.append($(app.config.modalsConfig.defaultContainerTpl));
	}
	app.modalLink = $('<a href="#' + 'lightbox"></a>');
	app.modalLink.sModal({
		closeButton : '#lightbox .modal_close, [role="lbx_wrapper"] .modal_close',
		onClose     : app.onNotificationEnd
	});

	var modalMessageHandlers = app.util.modalMessageHandlers();
    app.showModalMessageDefault = app.showModalMessage;
	app.showModalMessage = modalMessageHandlers.showModalMessageEnhanced;
	app.onModalClose = modalMessageHandlers.onModalClose;
	app.getModalsCurrentStateCopy = modalMessageHandlers.getModalsCurrentStateCopy;
	app.attachWsLbContainer();

	app.paymentMethod = $("#payment_method").val();
	app.userPaymentOptionId = parseInt($('#userPaymentOptionId').val());
	app.defaultLimits = {
		'minValue'    : (app.isOpenAmount) ? $('#item_min_amount_1').val() : app.amount,
		'maxValue'    : (app.isOpenAmount) ? $('#item_max_amount_1').val() : app.amount,
		'currencyIso' : app.currency
		//,'defaultAmount': app.amount
	};
	app.util.currencyExchange.setup({
		originalCurrencyIso       : app.config.currency,
		originalCurrencyPrecision : app.config.roundingScale,
		useFixedFraction		  : true,
		currencyFormatter         : _.identity, // OR app.formatter.formatDecimal,
		preselectAgreeDcc         : app.config.preselectAgreeDcc,
		PT_tpl                    : app.util.getLightboxContentTemplate('pt_currency_exchange'),
		DCC_tpl                   : app.util.getLightboxContentTemplate('dcc_exchange'),
		DCC_rate_tpl              : app.util.getLightboxContentTemplate('dcc_rate')
	});
	app.util.applyScrollablePlugin();
	//user_details:
	$('.payment_details ').on('click', '#user_details', function () {
		if (this.checked) {
			setTimeout(function () {
				app.util.applyScrollablePlugin();
				if (app.scroller && app.scroller.refresh) {
					app.scroller.scrollToElement($('.more_user_details').last()[0], 300);
				}
			}, 30);
		} else {
			setTimeout(function () {
				app.util.applyScrollablePlugin();
			}, 30);
			if (app.scroller && app.scroller.refresh) {
				app.scroller.scrollTo(0, 0, 300);
			}
		}
	});
	$(window).resize(app.util.applyScrollablePlugin);

	$('div[data-pms-type="dropdown"]').PMSelect(app.util.normalizePluginOpts(app.pluginOpts.PMSelect));
	$('div[data-pms-type="vertical"]').PMSelectV(app.util.normalizePluginOpts(app.pluginOpts.PMSelectV));
	$('div[data-pms-type="horizontal"]').PMSelectH(app.util.normalizePluginOpts(app.pluginOpts.PMSelectH));
	$('div[data-pms-type="table"]').PMSelectTable(app.util.normalizePluginOpts(app.pluginOpts.PMSelectTable));
	$('div[data-pms-type="accordion"]').PMSelectAccordion(app.util.normalizePluginOpts(app.pluginOpts.PMSelectAccordion));
	var $pms_type_grid = $('div[data-pms-type="grid"]');
	if ($pms_type_grid.length) {
		$pms_type_grid.PMSelectGrid(app.util.normalizePluginOpts(app.pluginOpts.PMSelectGrid));
	}
	var $plugin_type_ProductList = $('div[data-plugin-type="productlist"]');
	if ($plugin_type_ProductList.length) {
		if(app.config.isRebilling && defaults.RebillingData){
			$plugin_type_ProductList.Rebilling(app.pluginOpts.Rebilling);
			pubsub.publish('rebilling-available', [app.util.prepareRebillingData(defaults.RebillingData)]);
		} else {
			$plugin_type_ProductList.ProductList(app.util.normalizePluginOpts(app.pluginOpts.ProductList));
			// TODO: get ItemsCollection from FTL
			if (app.config.useNewPLEndPoints) { // TEMPORARY_FLAG BACKLOG-1080(getItemsInfo.do, addCrossSaleItem.do ...)
				var pl_cb = function (shouldSkipGT, onSuccessFn) {
					var _skipGT = !!shouldSkipGT;
					var _onSuccessFn = onSuccessFn || function () {};
					return function (result) {
						if (!result || !result.selectedItems) {
							app.showFinalMessage("general_error_text");
							return;
						}
						var dataObj = app.util.prepareProductListData(result, _skipGT);
						pubsub.publish('products-available', [dataObj]);
						_onSuccessFn(result);
					}
				};
				app.util.getItemsInfo(pl_cb(false, app.util.updateGrandTotalAmount));
				pubsub.subscribe('productlist-action', function (data) {
					app.util.doProductListAction(data.action, pl_cb(true, app.util.updateGrandTotalAmount), data);
				});
			}
		}
	}

	var $plugin_type_withdrawals = $('div[data-plugin-type="withdrawals"]');
	if ($plugin_type_withdrawals.length) {
		$plugin_type_withdrawals.PMWithdrawList(app.util.normalizePMWithdrawListOpts(app.pluginOpts.PMWithdrawList));
		app.util.withdrawalRequests();
	}
	if (!app.config.ptDoNotPrefillItemAmount) {
		app.util.setAmountValue(app.lastSelectedAmount, []);
	}

	app.util.initColorSettings();
	app.loadPMs();
	app.util.showLastTrxStatus(app.lastTrxData);
	app.util.showPtWarnings(app.ptWarnings);

	app.util.usePromoBox(app.config.promoBoxSrc, app.config.promoBoxCase,app.config.promoBoxContainer,app.config.promoBoxUrlExtend);

	if (app.config.isOpenAmount) {
		app.util.applySuggestPointsPlugin();
		app.util.setAmountElmNumberMask();
		app.util.maskedItemAmountPlugin = utils.MaskedAmount.init(false);
	}

	if(app.config.storeCard && app.config.storeCard.isActive && app.config.storeCard.merchantAdditionalInfoURL && !app.config.storeCard.useLightbox) {
		var cfgValue = app.config.themeConfig && app.config.themeConfig.openTermsInCustomLightbox;
		var shouldOpenTermsInCustomLightbox = typeof cfgValue === 'string' ? cfgValue === "true" : cfgValue;

		if(shouldOpenTermsInCustomLightbox) {
			app.config.storeCard.openTermsInCustomLightbox = true;
			app.config.storeCard.merchantAdditionalInfoURL = utils.addQueryStringParams(app.config.storeCard.merchantAdditionalInfoURL, {"hideCloseBtn": true});

			$(document).on('click', '#lightbox.lbx_scc_popup ~ .modalOverlay, #lightbox .scc_popup_footer-btn', function() { 
				$('#lightbox .modal_close').click();
			});
		}
	}

	/** @namespace app.userTrapMessages */
	if (app.userTrapMessages && app.userTrapMessages.length) {
		app.showModalMessage({details : app.userTrapMessages.join('<br>')}, app.CONSTANTS.MODAL_MESSAGE_TYPE.ERROR);
	}
    app.init_websocket_client();
};

app.normalizeConfig = function (config) {
	config.cardSupportedCurrencies = utils.remapCardSupportedCurrencies(config.cardSupportedCurrencies);
	if (config.pmSettings[app.CONSTANTS.PM_NAME.GOOGLE_PAY] && config.ptRequestId) {
		config.pmSettings[app.CONSTANTS.PM_NAME.GOOGLE_PAY].preDepositCheckUrl = app.CONSTANTS.PREDEPOSIT_CHECK_URL;
	}
	if (config.showRegisterPage) {
		config.showUserPMs = false;
	}
	if (config.pmHintConfig.showTableHint) {
		config.pmHintConfig.pmOnlyHints.splice(config.pmHintConfig.pmOnlyHints.indexOf('apmgw_MuchBetter'), 1);
	}
	config.installmentConfig.isActive = config.installmentConfig.programs.length > 0;
	config.analyticsConfig.allowInstallmentsPrograms = config.installmentConfig.isActive;
    if (config.installmentConfig.isActive) {
        config.allow_installments = false;
        config.allow_installments_for_card_type = "DISABLED";
        config.analyticsConfig.allowInstallments = false;
    }
	/** protection for some already customized themes **/
	if (config.doubleConfirmation || (config.isECommerce && !config.skipReviewTab)) {
		config.doubleConfirmByPm = {};
	}
	config.pmSupports3dsV2 = $.extend(true, {}, app.CONSTANTS.PM_SUPPORTS_3DSV2, config.use3dsForApple && {'ppp_ApplePay': 1});
	if (config.disregardPopupClose && config.disregardPopupClose.length) {
		// HACK START - MB WAY on Android - try to find a better solution later
		// {iOS: "relay_on_WS", Android: "relay_on_popupClose"}
		if (utils.getUserAgentInfo().android) {
			config.disregardPopupClose = _.filter(config.disregardPopupClose, function (v) {
				return v !== 'apmgw_MBWAY';
			});
		}
		// HACK END
		config.disregardPopupClose.forEach(function (pm) {
			var cfgId = config.disregardPopupCloseDefaultCfgId.hasOwnProperty(pm) ? config.disregardPopupCloseDefaultCfgId[pm] : 2;
			config.closePopupWndOnWsMessage[pm] = config.closePopupWndOnWsMessage[pm] || cfgId;
		});
	}
	return config;
};

app.storeConfig = function (cfg) {
	app.config = cfg;
	_.each(cfg, function (item, key) {
		app[key] = item;
	});
};

app.run = function (config) {
	var cfg = app.normalizeConfig(config);
	app.storeConfig(cfg);
	app.init(cfg);
	app.addEventSubscriptions(cfg);
};

app.addEventSubscriptions = function (config) {

	pubsub.subscribe('dr-select-pm', function (obj) {
		if (obj.uniqueId === 'cc_card' && app.lastSelectedMethodType === 'cc_card' && !obj.skipFldClear) {
			app.util.clearCardFields(app._pmFields['cc_card']);
			app.util.clearValidationState();
		}
	});

	pubsub.subscribe('post-pm-render', function(data) {
		if(app.config.showRegisterPage &&  ['cc_card', 'dc_card'].indexOf(app.lastSelectedMethodType) > -1) {
			if($('#continueButton').is('button')) {
				$('#continueButton').text(app.msg.add_card);
			} else {
				$('#continueButton').val(app.msg.add_card);
			}
		}
		var pmData = app._poList[app.lastSelectedMethodId];
		utils.renderBlockedPMReasons(pmData);

		if (app.config.pmHintConfig
			&& (app.config.pmHintConfig.showPMHint || app.config.pmHintConfig.alwaysShownHints.indexOf(data.value) > -1)) {
			app.util.showPaymentMethodHint(data.value, app.config.pmHintConfig.containerSelector);
		}

		if (data.value === 'visa_checkout') {
			$('body').addClass('main_visa_checkout');
			app.util.loadVcoScript();
			var btnelm = ($('#preSubmitButton').length) ? $('#preSubmitButton') : $('#continueButton');
			btnelm.after('<div id="vco" style="visibility: hidden;" ></div>');
			var btnColor = app.colorSettings.vco_btn_style; //  'neutral' | 'standard';
			$('#vco').append(
				'<div class="vco_btn_wrap"><img alt="Visa Checkout" class="v-button" role="button" src="' + app.config.vcoButtonUrl + '?color=' + btnColor + '"/></div>' +
				'<div class="vco_learn_wrap" style="width: 213px;"><a class="v-learn v-learn-default" href="#" data-locale="' + app.locale + '">' + app.msg.visa_checkout_tell_me_more + '</a></div>'
			);
		} else if (data.value === 'ppp_ApplePay') {
			app.util.handleApplePayBtn();
		} else if (data.value === app.CONSTANTS.PM_NAME.GOOGLE_PAY) {
			app.util.handleGooglePayBtn();
		} else if (app.lastSelectedMethodId === app.CONSTANTS.PM_NAME.OCTOPUS) {
			app.util.validateFixedAmountDecimalPlaces({"HKD": 1});
		}

		if (app.CONSTANTS.CRYPTO_CONSENT_PMS[app.lastSelectedMethodId]) {
			utils.showConsentPopupForCryptoPMs(app.lastSelectedMethodId);
		}

		utils.storeCardCredentialsHandler(app.config.storeCard, app.lastSelectedMethodType );
		app.util.handlePromotedPmHint();
		app.util.openPromoCodeToggleIfItHasValue();
		app.util.handleTogglePromocodeValidation();
	});

	pubsub.subscribe('post-upm-render', function(data) {
		var pmData = app._upoList[app.lastSelectedMethodId];
		app.util.renderUpoMessage(pmData);
		app.util.validateRoCardField('post-upm-render');
		utils.renderBlockedPMReasons(pmData);
		if (app.lastSelectedMethodType === 'visa_checkout') {
			app.util.loadVcoScript();
		} else if (app.lastSelectedMethodType === 'ppp_ApplePay') {
			app.util.handleApplePayBtn();
		} else if (app.lastSelectedMethodType === app.CONSTANTS.PM_NAME.GOOGLE_PAY) {
			app.util.handleGooglePayBtn();
		} else if (app.lastSelectedMethodType === app.CONSTANTS.PM_NAME.OKTO_WALLET) {
			app.util.handleOktoWalletConsent();
		} else if (app.lastSelectedMethodType === app.CONSTANTS.PM_NAME.OCTOPUS) {
			app.util.validateFixedAmountDecimalPlaces({"HKD": 1});
		}
		var upoSupportsHint = app.config.pmHintConfig && app.config.pmHintConfig.pmOnlyHints.indexOf(data.userPaymentMethodName) === -1;
		var isAlwaysOnHint = app.config.pmHintConfig && app.config.pmHintConfig.alwaysShownHints.indexOf(data.userPaymentMethodName) > -1;
		var inQD = app.config.quickDeposit.isShow;
		if (upoSupportsHint) {
			if (inQD && app.config.pmHintConfig.quickDepositShownHints.indexOf(data.userPaymentMethodName) > -1
				|| !inQD && (app.config.pmHintConfig.showPMHint || isAlwaysOnHint)) {
				app.util.showPaymentMethodHint(data.userPaymentMethodName, app.config.pmHintConfig.containerSelector);
			}
		}
		if (app.CONSTANTS.PMS_WITH_DUMMY_CARD_UPO[app.lastSelectedMethodType]) {
			utils.storeCardCredentialsHandler(app.config.storeCard, app.lastSelectedMethodType);
		}
		if (app.CONSTANTS.CRYPTO_CONSENT_PMS[app.lastSelectedMethodType]) {
			utils.showConsentPopupForCryptoPMs(app.lastSelectedMethodType);
		}
		app.util.handlePromotedPmHint();
		app.util.openPromoCodeToggleIfItHasValue();
		app.util.handleTogglePromocodeValidation();
	});

	pubsub.subscribe('select-pm', app.onPMSelected);
	pubsub.subscribe('remove-upm', app.onRemoveUPM);
	pubsub.subscribe('safecharge.global.error', app.showFinalMessage);
	pubsub.subscribe('safecharge.transaction.complete', function (data) {
		if (app._popupWnd || app._flag.lastApmOpenedInFrame) {
			var isWs = data && data.eventType === "websocket";
			var feRef = data && data.details && data.details.feRef;
			var pmName = data && data.details && data.details.payment_method;
			var isWsSupportedStatus = ["PENDING", "UPDATE", "A2ERROR"].indexOf(data.trxStatus) === -1;
			if (isWsSupportedStatus || !isWs) {
				app.postponedTrxOnApmClose.push(data);
			}
			if (app._flag.lastApmOpenedInFrame && (!isWs || app._flag.lastApmOpenedInFrame === pmName)) {
				app.util.closeTargetIframe();
			}
			if (app._popupWnd && isWs
				&& app.config.closePopupWndOnWsMessage[pmName]
				&& app.submittedMethod
				&& app.submittedMethod.feRef === feRef
				&& app.submittedMethod.pmName === pmName
			) {
				var closePopUpStatuses = app.util.getStatusesByCfgId(app.config.closePopupWndOnWsMessage[pmName]);
				if (_.includes(closePopUpStatuses, data.trxStatus)) {
					app.util.closePopUpWindow(pmName, 'ws');
					if (_.includes(app.config.disregardPopupClose, pmName) && !isWsSupportedStatus){
						apmPopupClosedCallback();
					}
				}
			}
		} else {
			app.onTransactionComplete(data);
		}
	});
	pubsub.subscribe('popupWndClose', app.util.presentPostponedTrxOnApmClose);
	pubsub.subscribe('targetIframeClose', app.util.presentPostponedTrxOnApmClose);
	pubsub.subscribe('safecharge.from_3d_iframe', app.util.on3dIfameReady);
	pubsub.subscribe('app.event.performRedirect', app.util.onPerformRedirect);
	pubsub.subscribe('safecharge.PWMB.authorization.ready', app.util.onPwmbAuthorizationSuccessDoSubmit);
	pubsub.subscribe('safecharge.subscription.complete', app.util.onPubsubSubscriptionComplete);
	pubsub.subscribe('safecharge.createOrder.response', function (data) {
		app.util.FeRef.setRefData(data.feRef , "createOrderResp", $.extend(true, {}, data));
	});

	if (config.showValidationResult) {
		pubsub.subscribe('app.event.DepositClicked', app.util.showValidationResult);
	}
	pubsub.subscribe('withdraw-cancel', app.util.withdrawalCancel);

	pubsub.subscribe('products-available', app.util.reInitVisaCheckout);
	pubsub.subscribe('app.event.currencyChanged', app.util.reInitVisaCheckout);
	pubsub.subscribe('app.event.RestrictionsApplied', app.util.reInitVisaCheckout);
	pubsub.subscribe('app.event.FixedAmountRestrictionsApplied', app.util.reInitVisaCheckout);
	pubsub.subscribe('suggest-point-selected', app.util.reInitVisaCheckout);

	pubsub.subscribe('app.event.formValidationResult', function() {
		if (!app.config.isOpenAmount && app.lastSelectedMethodType === app.CONSTANTS.PM_NAME.PLAY_PLUS) {
			var $sightlineEnrolBtn = $("#sightline_enrollButton_validation");
			$sightlineEnrolBtn.empty();
			if (app._validationResult.item_amount_1 && app._validationResult.item_amount_1.validatorKey === "testPlayPlusBalance") {
				$sightlineEnrolBtn.append($("<label class='error'>").text(app._validationResult.item_amount_1.message));
			}
		}
	});

	if (config.useDcc && config.useCurrencyExchange) {
		pubsub.subscribe('app.event.preferred_currency_change', app.util.onDccPrefCurrencyChange);
		pubsub.subscribe('app.event.agreeDcc_change', app.util.onDccPrefCurrencyChange);
	}
	pubsub.subscribe('app.event.pm_normalized_currencies', app.util.storeCurrentMethodCurrencies);
	pubsub.subscribe('inlineMessage.closed', app.util.onInlineMessageClose);

	app.util.handleSubPages(app.config.useSubpages);

	/** <fix iScroll Vertical behaviour START> */
	$('[data-plugin="scrollable"].scrollable .scroll-container').on('keyup', utils.onTabPressFixIScrollV);
	$('[data-plugin="scrollable"].scrollable').on('scroll', function (e) {
		$(this).scrollTop(0);
	});
	/** <fix iScroll Vertical behaviour END/> */

	$(document).on('safecharge.session.expired', function () {
		if (app._flag.lastApmOpenedInFrame && app.lastSelectedMethodType === app._flag.lastApmOpenedInFrame) {
			app.util.closeTargetIframe();
		}
		app.showFinalMessage(app.CONSTANTS.SRV_RESPONSE.MSG_SESSION_EXPIRED);
	});

	/** Prevent Auto Form submit when "Enter" is pressed */
	$(document).on('keyup, keypress', 'input', function (ev) {
		if (ev.keyCode === 13) {
			ev.preventDefault();
			return false;
		}
	});

	$(document).on('change', '.directFlowCheckbox, #allowSaveUpo, #sccToggle, #bancontactOneClickToggle', app.util.onCheckboxChange);
	if(config.installmentConfig.isActive){
		$(document).on('change', '#installment_program', app.util.onInstallmentProgramFldChange);
	} else if(config.allow_installments || config.allow_special_debit){
		$(document).on('change', '#debit_type', app.util.onDebitTypeFldChange);
	}

	if(config.allow_installments && config.allow_installments_for_card_type !== 'DISABLED')  {
		pubsub.subscribe('app.event.card_recognition_complete', function(cardDetails) {
			if(app._cardInfo && app._cardInfo.slave_brand === "israeli_card") {
				return;
			}

			var	response = cardDetails.resp;
			if(response && app.util.isEligibleCardForInstallments(response.cardType,  app.config.allow_installments_for_card_type)) {
				app.util.enableInstallmentsForCardType();
			} else {
				app.util.disableInstallmentsForCardType();
			}

			if(response && response.cardType) {
				app.util.handleInstallmentsForCardTypeWarning(response.cardType,  app.config.allow_installments_for_card_type);
			}

		});
	}

	// muchBetter_mobilePhone, mbWay_mobilePhone ...
	$(document).on("change", "#country_phone_code", app.util.prepareCompositePhoneForValidation);
	$(document).on("blur", "#composite_phone_suffix", app.util.prepareCompositePhoneForValidation);
	if (app.config.pmSettings.apmgw_QIWI.showQiwiCountryCodes) {
		$(document).on("change", "#qiwi_country_code", app.util.prepareQiwiForValidation);
		$(document).on("blur", "#qiwi_phonenumber_suffix", app.util.prepareQiwiForValidation);
	}

	$(document).on('click', '.try_pm > .support', app.util.onDrContactSupport);

	$(document).on('click', '#entropay_registration_flow', app.util.entropayRegistrationFlow);

	$(document).on('click', '.send_message', utils.sendPostMessageFromAttr);

	if (app.config.storeCard && app.config.storeCard.isActive) {
		$(document).on('click', '.scc .open-terms', utils.showStoreCardTerms);
	}

	if (app.config.isRebilling && app.config.rebillingTermsUrl) {
		$(document).on('click', '#rebilling_terms_link', app.util.onRebillingTermsLinkClicked);
		$(document).on('click', 'label[for="rebilling_terms_checkbox"][data-terms_read="0"]', app.util.onRebillingTermsCheckboxChange);
	}

	if (app.config.allowDeleteUPO) {
		$(document).on('click', (app.config.removeUpoSelector || '.removeUPM'), function () {
			var $this = $(this);
			var uniqueId = $this.data('value');
			var data = app._pmFields[uniqueId] || {};
			data.userPaymentMethodName = $this.data('method');
			data.id = data.userPaymentOptionId || uniqueId;
			if (!data.card_type && app.util.isCardPM(data) && $this.data('card_type')) {
				data.card_type = $this.data('card_type');
			}
			app.onRemoveUPM(data);
		});
	}

	var itemAmountOneElm = $("#item_amount_1");
	if (app.util.getURLParameter("item_open_amount_1") == "true" && itemAmountOneElm.val() == 0) { // AN??
		app.util.setAmountValue('', []);
	}

	pubsub.subscribe('app.event.PMDataAvailable', function (upm, pm) {
		if (!upm.length && !pm.length) {
			app.showModalMessage({message: {text: 'no_payment_options', titleKey: 'no_payment_data' } }, 'error_blocking');
		}
	});

	$(document).on('change', '#promoCode_checkbox', function(el){
		app.util.handleTogglePromocodeValidation();
	});
};

/**
 * isIframe = true|false
 * < IF false > - PM should use POPUP window
 */
function setContinueButtonAction(data) {
	var continueButtonElm = $("#continueButton");
	var inPopupModeElm = $('#inPopupMode');
	var inIframeModeElm = $('#inIframeMode');
	continueButtonElm.removeAttr("onclick");
	continueButtonElm.off();
	var isSubmited = false;
	var _continueButtonHandler;

	/** @namespace app.isMobile */
	if (!app.util.isCardPM(data) && app.isMobile) {
		app.continueButtonHandler = function (event, silent, customAction) {
			if (_asyncCheckInProgress(event, silent, customAction)) {
				return;
			}
			if (!silent){
				pubsub.publish('app.event.DepositClicked', []);
			}

			$.blockUI();
			inPopupModeElm.val('false');
			inIframeModeElm.val('false');
			submitForm(customAction, silent);
		};
		return;
	}

	app.continueButtonHandler = _wrapAndInjectPreCheck(_baseHandler);
	if (data.uniqueId === 'ppp_ApplePay'|| data._onContinueTreatItLikePm === 'ppp_ApplePay' ) {
		/** continueButtonElm does NOT have to exist (there is a '#apple-pay-button'), but we process it just in case **/
		return continueButtonElm.on("click", app.util.handleApplePayBtn);
	}
	if (data.uniqueId === 'ppp_AndroidPay' && !app.openedInIframeMode && !window['PaymentRequest']) {
		return continueButtonElm.on("click", androidPay.getToken);
	}
	if (data.uniqueId === 'ppp_AndroidPay' && window['PaymentRequest']) {
		return continueButtonElm.on("click", app.util.handleAndroidPay);
	}
	if (data.uniqueId === app.CONSTANTS.PM_NAME.GOOGLE_PAY || data._onContinueTreatItLikePm === app.CONSTANTS.PM_NAME.GOOGLE_PAY) {
		/** continueButtonElm does NOT have to exist (there is a '#google-pay-button'), but we process it just in case **/
		return continueButtonElm.on("click", app.util.handleGooglePayBtn);
	}
	if (data.uniqueId === 'apmgw_Venmo') {
		/** continueButtonElm does NOT have to exist (there is a '#venmo-button'), but we process it just in case **/
		return continueButtonElm.on("click", app.util.handleVenmoBtn);
	}

	if (data.uniqueId === app.CONSTANTS.PM_NAME.PAY_WITH_MY_BANK || data._onContinueTreatItLikePm === app.CONSTANTS.PM_NAME.PAY_WITH_MY_BANK) {
		_continueButtonHandler = function (event, silent, customAction) {
			if (_isReadyForSubmit(event, silent, customAction) && app.validateForm()) {
				utils.pwmb.renderLbx();
			}
		};
	} else if (data.uniqueId === 'apmgw_Citi_Pay_MIL' || data._onContinueTreatItLikePm === 'apmgw_Citi_Pay_MIL' ||
			data.uniqueId === 'apmgw_Citi_Pay_DLOC' || data._onContinueTreatItLikePm === 'apmgw_Citi_Pay_DLOC') {
		_continueButtonHandler = function (event, silent, customAction) {
			if (_isReadyForSubmit(event, silent, customAction) && app.validateForm()) {
				app.util.CitiPay.renderLightbox();
			}
		};
	} else if ((app.lastSelectedMethodId === 'cc_card' || app.lastSelectedMethodId === 'dc_card') && app.config.pmSettings.c2p.enabled) {
		_continueButtonHandler = function (event, silent, customAction) {
			if (_isReadyForSubmit(event, silent, customAction) && app.validateForm()) {
				var isIframe = data.isIframe && data.isIframe.toString() === "true";
				app.util.c2p.selectFlowAndSubmit(customAction, silent, isIframe);
			}
		};
	} else if (app.config.isRebilling) {
		_continueButtonHandler = function (event, silent, customAction) {
			if (_isReadyForSubmit(event, silent, customAction) && app.validateForm()) {
				app.sub.doSubscribe(customAction, silent);
			}
		};
	} else if (data.isIframe && data.isIframe.toString() === "true") {
		_continueButtonHandler = function (event, silent, customAction) {
			if (_isReadyForSubmit(event, silent, customAction)) {
				submitInIframe(customAction, silent);
			}
		};
		if (inPopupModeElm.length) {
			inPopupModeElm.val('false');
		}
	} else {
		_continueButtonHandler = function (event, silent, customAction) {
			if (_isReadyForSubmit(event, silent, customAction)) {
				submitPopupForm(customAction, silent);
			}
		};
	}
	app.continueButtonHandler = _wrapAndInjectPreCheck(_continueButtonHandler);
	continueButtonElm.on("click", app.continueButtonHandler);

	/***************  setContinueButtonAction helpers Start  *************/
	function _baseHandler(event, silent, customAction) {
		if (_isReadyForSubmit(event, silent, customAction) && app.validateForm(customAction)) {
			if (app.config.isRebilling) {
				app.sub.doSubscribe(customAction, silent);
			} else {
				submitInIframe(customAction, silent);
			}
		}
	}

	function _asyncCheckInProgress(event, silent, customAction) {
		var checkInProgress = !app.util.asyncCheck.isComplete();
		if (checkInProgress) {
			app.util.asyncCheck.onComplete(function (r, val) {
				var newV = $('#cc_card_number').val();
				if (newV == val && !isSubmited && r && r.isCardAllowed) {
					isSubmited = true;
					app.continueButtonHandler(event, silent, customAction);
				}
			}, 'hashKey_yacoreng');
		}
		return checkInProgress;
	}

	function _isReadyForSubmit(event, silent, customAction) {
		var _proceed = true;
		if (event && event.stopPropagation) {
			event.stopPropagation();
			event.preventDefault();
		}
		if (_asyncCheckInProgress(event, silent, customAction)) {
			_proceed = false;
		}
		return _proceed;
	}

	function _wrapAndInjectPreCheck(submitFn) {
		return function _onDepositClickHandler(event, silent, customAction) {
			if (_isReadyForSubmit(event, silent, customAction)) {
				if (!silent) {
					pubsub.publish('app.event.DepositClicked', []);
				}
				if (!app.validateForm(customAction)) {
					pubsub.publish('submit-attempt-failed', [app.util.getSubmitAttemptFailedData(false)]);
					return;
				}
				var doProceed = function () {
					submitFn(event, silent, customAction);
				};
				var predepositHandler = function () {
					if(app.util.hasPTPredepositCheckForPM(app.lastSelectedMethodType)) {
						app.util.handlePredepositChecks(doProceed);
					} else {
						doProceed();
					}
				};

				if (app.util.handlePreDepositLightboxes(predepositHandler, {silent: silent, customAction: customAction})) {
					predepositHandler();
				}
			}
		}
	}

	/***************  setContinueButtonAction helpers End  *************/
}

app.validateForm = function (action, omitValidationMsgs) {
	if (action) {
		document.forms[0].action = action;
		if (action === 'cancel.do') {
			document.forms[0]['pppAction'].value = 'cancelByUser';
		}
		if (action === 'partialChoice.do') {
			return true;
		}
	}
	var formIsValid = true;
	if (!app.config.isRebilling) {
		app.currentMethodFields.item_amount_1 = {type : 'REQUIRED'};
	}
	if (app.config.showRegisterPage || app.util.isFbtLikePm(app.lastSelectedMethodType)) {
		app.currentMethodFields.item_amount_1 = {type : 'HIDDEN'};
	}

	var pmData = app.util.isUpo(app.lastSelectedMethodId) ? app._upoList[app.lastSelectedMethodId] : app._poList[app.lastCardDetected] || app._poList[app.lastSelectedMethodId] || {};
	var isPMBlocked = utils.isPMBlocked(pmData);
	if (!_.isEmpty(isPMBlocked)) {
		app.currentMethodFields.blocked_method = {type : 'REQUIRED'};
	} else {
		app.currentMethodFields.blocked_method = {type : 'OPTIONAL'};
	}

	_.each(app.currentMethodFields, function (fldDetail, fieldName) {
		if (fldDetail.isTmpDisabled
			|| fldDetail.type === 'DISABLED'
			|| fldDetail.type === 'HIDDEN'
			|| (_.findIndex(srvPmFields, function (o) {
					return o.name === fieldName
				}) === -1
				&& !app.CONSTANTS.EXTRA_FIELDS_FOR_VALIDATION[fieldName])
		) {
			return true;
		}
		if (fieldName === 'expiration_period') {
			var names = app.util.getDateFieldNames(app.currentMethodFields);
			if (fldDetail[names.expMonthId].type === 'DISABLED' || fldDetail[names.expYearId].type === 'DISABLED'
				|| fldDetail[names.expMonthId].type === 'HIDDEN' || fldDetail[names.expYearId].type === 'HIDDEN'
			) {
				// Do Nothing
			} else {
				var expYearVal = parseInt($('#' + names.expYearId).val()) + 2000;
				var expMonthVal = parseInt($('#'+ names.expMonthId).val());
				var expDate = ( expMonthVal < 0 || expMonthVal > 12 ) ? new Date('Invalid Date') : new Date(expYearVal, expMonthVal, 1, 0, 0, 0, -1);
				formIsValid = app.util.validateField(fieldName, expDate, null, 'auto', omitValidationMsgs) && formIsValid;
			}
		} else {
			var fieldVal = app.util.getFieldValue(fieldName);
			formIsValid = app.util.validateField(fieldName, fieldVal, null, 'auto', omitValidationMsgs) && formIsValid;
		}
	});
	// Validate custom fields
	var checkbox = $('#user_details');
	var billingFields = app._billingFieldsForValidation || [];
	_.each(customFieldsForValidation, function (fieldName) {
		var isValid = true;
		var inputElm = $('#' + fieldName);
		if (inputElm.length) {
			var fieldVal = inputElm.val();
			if (!inputElm.data('skipValidation')) {
				isValid = app.util.validateField(fieldName, fieldVal, null, 'auto', omitValidationMsgs);
			}
		} else {
			var $radioArr = $('input[type="radio"][name="' + fieldName + '"]');
			if ($radioArr.length) {
				fieldVal = $radioArr.filter(":checked").val();
				isValid = app.util.validateField(fieldName, fieldVal, null, 'auto', omitValidationMsgs);
			}
		}
		if (!isValid) {
			formIsValid = false;
			if (!omitValidationMsgs && checkbox.length && (!checkbox[0].checked)
				&& billingFields.length && billingFields.indexOf(fieldName) > -1
			) {
				checkbox.click();
			}
		}
	});
	pubsub.publish('app.event.formValidationResult', [formIsValid]);
	return formIsValid;
};

app.applyOneRowDate = function (wrapperSelector) {
	wrapperSelector = wrapperSelector || '.PMINFO';
	var oneRowDate = $(wrapperSelector + ' .oneRowDate');
	if (oneRowDate.length) {
		var mFldName = app.util.getPmSpecificFldName('cc_exp_month', app.lastSelectedMethodType);
		var yFldName = app.util.getPmSpecificFldName('cc_exp_year', app.lastSelectedMethodType);
		app.util.oneRowExpDate('#exp_date', '.cc-exp-date', {
			expMonthId : mFldName,
			expYearId  : yFldName
		});
	}
};

function submitForm(customAction, silent) {
	var action = _.isString(customAction) ? customAction : 'review.do';
	var proceed = true;
	// what about Deposit Confirmations? - should we skip InitAuth3d?
	

	var shouldInitAuth3d = app.shouldInitAuth3d(action);
	app.util.imsAnalytics.attachAnalyticsToForm();
	_preFormSubmit(customAction, silent);
	var params = {
		silent       : silent,
		customAction : customAction
	};
	var doProceed = (function (_params, _shouldInitAuth3d) {
		return function () {
			$('#continueButton').off();
			_normalizeSubmittedValues();
			if (_shouldInitAuth3d) {
				return app.initAuth3d().then(function () {
					return finalizeSubmit(_params);
				});
			} else {
				return finalizeSubmit(_params);
			}
		}
	})(params, shouldInitAuth3d);

	if (app.customPreFormSubmit) {
		proceed = app.customPreFormSubmit(params);
	}
	var asyncCheckCompleted = app.util.asyncCheck.isComplete();
	if (proceed && asyncCheckCompleted && app.validateForm(action)) {
		closePopups();
		proceed = app.util.handleSccLightbox(doProceed, params);
	} else {
		pubsub.publish('submit-attempt-failed', [app.util.getSubmitAttemptFailedData(!asyncCheckCompleted)]);
	}
	if (proceed) {
		return doProceed();
	}
	return false;

	/***************  submitForm helpers Start  *************/
	function _preFormSubmit(customAction, silent) {
		if (app.lastSelectedMethodType === 'apmgw_expresscheckout' &&
			app.util.isUpo(app.lastSelectedMethodId) &&
			app._pmFields[app.lastSelectedMethodId] &&
			app._pmFields[app.lastSelectedMethodId]['hasReferenceId'] &&
			$('#paypalDirectFlow').is(':checked')) {
			app.util.paypalFraudNetHandler();
		}
		if (!silent && app.util.FeRef.isUsed(app._lastFeRef)) {
			app.util.FeRef.generateNext(app._lastFeRef);
		}
	}
	function _normalizeSubmittedValues() {
		app.util.handleDankortVisa();
		if (!$('#inPopupMode').length && !$('#inIframeMode').length) {
			$.blockUI({ignoreIfBlocked: true});
		}
		$('input#nettelerAccount').each(function () {
			var elm = $(this);
			elm.val(elm.val().trim());
		});
		if ('apmgw_Webmoney_SMS_Invoice_' === app.lastSelectedMethodType) {
			app._WM_sms = $('#webmoney_sms').is(':checked');
		}
		if (app.config.showRegisterPage ||
			app.config.allowZeroAmountPMs.indexOf(app.lastSelectedMethodType) > -1 ||
			(app.lastSelectedMethodType === app.CONSTANTS.PM_NAME.LEAN && !app.util.isUpo(app.lastSelectedMethodId)) ||
			(app.lastSelectedMethodType === app.CONSTANTS.PM_NAME.OKTO_WALLET && $("#oktowallet_consent").is(":checked"))
		) {
			app.util.setAmountValue(0, []);
			app.lastSelectedAmount = 0;
		}
	}

	/***************  submitForm helpers END  *************/
}

function finalizeSubmit(params) {
	app._logger.log('Submit');
	app._logger.log_2({msg : 'SENT', data : $(document.forms[0]).serializeArray()});
	app.submittedMethod = app.util.getCurrentMethodInfo();
	app.util.FeRef.setRefData(app._lastFeRef, "submittedMethod", $.extend(true, {}, app.submittedMethod));
	if (!params.silent) {
		pubsub.publish('app.event.formSubmit', [$.extend(true, {}, app.submittedMethod)]);
	}
	document.forms[0].submit();
	_postFormSubmit(params);
	return true;
}

function _postFormSubmit(params) {
	pubsub.publish('post-form-submit', [$.extend(true, {}, app.submittedMethod, params)]);
    $('#continueButton').blur();        // prevent resubmit by pressing Space bar or Enter
	$('#inPopupMode').val('false');
	var cvvElm = $('#cc_cvv2');
	if (cvvElm.length) {
		app._oldCVV = cvvElm.val();
		cvvElm.val("");
	} else {
		app._oldCVV = '';
	}
	if (app.util.shouldOpenInExternalBrowser(app.submittedMethod.id)) {
		if (!app.submittedMethod.isUpo || $('#inIframeMode').val() !== "true") {
			$.unblockUI();
		}
	}
}

/**
 * 3DS_v2
 *
 * @returns {jQuery Promise}
 */
app.initAuth3d = function () {
	var def = $.Deferred();
	var additionalData = {
		javaEnabled         : navigator.javaEnabled(),
		browserLanguage     : navigator.language,
		browserColorDepth   : screen.colorDepth || 24,
		browserScreenHeight : screen.height,
		browserScreenWidth  : screen.width,
		browserTimeZone     : (new Date()).getTimezoneOffset(),
		javaScriptEnabled   : true,
		totalAmount         : app.lastSelectedAmount
	};
	var data_to_send = $.extend(true, app.util.getFormDataAsObject($(document.forms[0])), additionalData);

	$.ajax({
		type		: "POST",
		url			: "/ppp/initAuth3d.do?ssid=" + app.ssid,
		contentType	: "application/json",
		dataType	: "JSON",
		data		: JSON.stringify(data_to_send),
	}).always(function (data) {
		return onInitAuth3dDone(data);
	});

	function onInitAuth3dDone(auth3dResponse){
		if (auth3dResponse && auth3dResponse.support3Dv2) {
			app.util.addTmpFormData(additionalData);
			if (auth3dResponse.threeDSMethodURL && auth3dResponse.threeDSMethodPayload) {
				return _doSubmitAndWait10seconds(auth3dResponse)
					.then(function () {
						$("#3dsMethodFormWrapper").remove();// fn REMOVE hidden Iframe
						def.resolve(additionalData);
					});
			}
		}
		def.resolve(additionalData);
	}

	/***************  initAuth3d helpers Start  *************/
	function _doSubmitAndWait10seconds(auth3dResponseData) {
		var _def = $.Deferred();
		var timer = setTimeout(_onIframeResponseOrTimeout, 11000);
		var subscribeObj = pubsub.subscribe('3dMethodIssuerResponse', _onIframeResponseOrTimeout);
		function _onIframeResponseOrTimeout() {
			clearTimeout(timer);
			pubsub.unsubscribe(subscribeObj);
			_def.resolve();
		}
		_submit3dDataInHiddenIframe(auth3dResponseData);
		return _def.promise();
	}

	function _submit3dDataInHiddenIframe(data) {
		$("#3dsMethodFormWrapper").remove();
		$('body').append('<div id="3dsMethodFormWrapper" style="display: none">' +
			'<form id="3dsMethodForm" name="3dsMethodForm" method="POST" action="' + data.threeDSMethodURL + '" target="hidden3dIframe">' +
			'<input type="hidden" name="threeDSMethodData" value="' + data.threeDSMethodPayload + '">' +
			' </form>' +
			'<iframe name="hidden3dIframe" id="hidden3dIframe"></iframe></div>');
		$('#3dsMethodForm').submit();
	}
	/***************  initAuth3d helpers End  *************/

	return def.promise();
};

app.shouldInitAuth3d = function (action, pmName, uniqueId, brand) {
	pmName = pmName || app.lastSelectedMethodType;
    uniqueId = uniqueId || app.lastSelectedMethodId;
    brand = brand || app.lastCardDetected;

	var shouldInitAuth3d = app.config.use3dsv2 &&
						   (action !== 'partialChoice.do') &&
						   app.config.pmSupports3dsV2[pmName];

	if(shouldInitAuth3d) {
		var upoData = app.util.isUpo(uniqueId) && app._upoList[uniqueId] || {};
		var is3DSExcludedCardBrand = app.config.excludedThreeDSCardBrands.length && _.includes(app.config.excludedThreeDSCardBrands, brand);
        var isBancontactOneClickFlow = app.config.useBancontactOneClick && upoData.oneClickPaymentSelectorLastValue === "true" && brand === "bancontact";
        var skip3ds = isBancontactOneClickFlow || is3DSExcludedCardBrand;

        shouldInitAuth3d = !skip3ds;
	}
	
	return shouldInitAuth3d;
};

function closePopups() {
	var currencyPopupElm = $("#currency_popup");
	if (currencyPopupElm.length && !(currencyPopupElm.hasClass('hide'))) {
		$("#close_currency_popup").trigger('click');
	}
}

function submitInIframe(action, silent) {
	var asyncCheckCompleted = app.util.asyncCheck.isComplete();
	if (!asyncCheckCompleted || !app.validateForm(action)) {
		pubsub.publish('submit-attempt-failed', [app.util.getSubmitAttemptFailedData(!asyncCheckCompleted)]);
		return;
	}
	var opt = {
		blockMsgClass: app.lastCardDetected === 'none' ? 'blockMsg': 'blockMsg threeD_' + app.lastCardDetected
	};
	if (app.util.isBancontactOneClickFlow(app.lastSelectedMethodId, app.lastCardDetected)) {
		opt.blockMsgClass += ' bancontactOneClickAvailable';
	}
	$.blockUI(opt);
	app.util.setupTargetIFrame();
	$('#PPPParametersForm').attr('target', 'targetIFrame');
	$('#inIframeMode').val('true'); //TODO: smell - wrong place
	submitForm(action, silent);
}

function submitPopupForm(action, silent) {
	$.blockUI();
	if (!app.validateForm(action)) {
		pubsub.publish('submit-attempt-failed', [app.util.getSubmitAttemptFailedData(false)]);
		unblockUI();
		return;
	}
	var url = 'blank.html?ssid=' + app.ssid + "&locale=" + app.config.locale + '&pmid=' + app.lastSelectedMethodId;
	var isNativeAppFlow_1 = (app.util.shouldOpenInExternalBrowser(app.lastSelectedMethodId) && app.config.nativeAppFlow === '1');
	if (app.config.isNative && !(app.config.isNativeExceptions.indexOf(app.lastSelectedMethodType) > -1) && !isNativeAppFlow_1) {
		if(app.config.useDepositConfirmations && !app.config.skipPTPredepositCheck && !app.util.hasPTPredepositCheckForPM(app.lastSelectedMethodType)) {
			app.util.handlePredepositChecks(_submitForm);
		} else {
			_submitForm();
		}

		function _submitForm() {
			var target = "_self";
			if (app.config.openPmInTopWindow && (app.config.openPmInTopWindow[app._deviceType][app.lastSelectedMethodType]) || app.config.openPmInTopWindow[app._deviceType]["ALL"]) {
				target = "_top";
			}
			$('#PPPParametersForm').attr('target', target);
			$('#inPopupMode').val('false');
			$('#inIframeMode').val('false');
			submitForm(action, silent);
		}
	} else if (
		app.config.openPmInFrame && (app.config.openPmInFrame[app._deviceType][app.lastSelectedMethodType] || app.config.openPmInFrame[app._deviceType]["ALL"])
		|| isNativeAppFlow_1
	) {
		app.util.setupTargetIFrame();
		$('#targetIFrame').attr('src', url);
		app.show3DIFrame({
			iframeMaxHeight: 850,
			iframeWidth: 950
		});
		$('#PPPParametersForm').attr('target', 'targetIFrame');
		$('#inPopupMode').val('false');
		$('#inIframeMode').val('true');
		app._flag.lastApmOpenedInFrame = app.lastSelectedMethodType;
		setTimeout(function () {
			submitForm(action, silent);
		}, 500);
		$.unblockUI();
	} else {
		var popupName = 'pppApmWindow_' + (new Date()).getTime();
		var popupWnd = app.util.createPopupWindow(app.lastSelectedMethodType, url, popupName);
		var shouldIgnorePopupCloseEvent = app.config.disregardPopupClose && _.includes(app.config.disregardPopupClose, app.lastSelectedMethodType);
		var _wsProxyPromise = null;

		if (app.config.backToRedirectPage) {
			app.util.backToRedirectPageHandler(popupWnd);
		}

		$('#PPPParametersForm').attr('target', popupName);
		$('#inPopupMode').val('true');
		$('#inIframeMode').val('false');
		app._popupWnd = popupWnd;

		if (shouldIgnorePopupCloseEvent) {
			var cfg = app.config.ws_proxy_config;
			if (!app.util.Ws.isRunning() && cfg && cfg.wssUrl) {
				var wsProxyCfg = {
					ssid: app.config.ssid,
					pmName: app.lastSelectedMethodType,
					wssUrl: cfg.wssUrl + "/ws",
					proxyUrl: cfg.proxyUrl,
					forceDeepClean: cfg.forceDeepClean
				};
				_wsProxyPromise = app.util.Ws.proxy.load(wsProxyCfg);
			}
		}

		function _onWsProxyLoad() {
			if (_wsProxyPromise) {
				_wsProxyPromise
					.then(function () {
						var cfgId = app.config.closePopupWndOnWsMessage[app.lastSelectedMethodType];
						app.util.Ws.proxy.listenFor(
							app._lastFeRef,
							app.lastSelectedMethodType,
							app.util.getStatusesByCfgId(cfgId));
					})
					.fail(function (err) {
						console.log(err);
						app._logger.log('WS_PROXY FAIL! pm=' + app.lastSelectedMethodType + '; err= ' + err);
						waitPopupClose(popupWnd, apmPopupClosedCallback);
					});
			}
		}

		var _timeout = app.util.calcSubmitInPopupDelay(app.lastSelectedMethodType);
		setTimeout(function () {
			var formIsSubmitted = submitForm(action);
			if (formIsSubmitted) {
				try {
					popupWnd.focus();
				} catch (e) {
				}
				if (shouldIgnorePopupCloseEvent && _wsProxyPromise) {
					_onWsProxyLoad(); // ignore popup close and wait for WS notification
				} else if (shouldIgnorePopupCloseEvent && app.util.Ws.isRunning()) {
					// Do nothing! wait for WS notification
				} else {
					waitPopupClose(popupWnd, apmPopupClosedCallback);
				}
			} else {
				$.unblockUI();
				app.util.closePopUpWindow(app.lastSelectedMethodType, 'submitForm');
			}
		}, _timeout);
	}
}

function apmPopupClosedCallback(initiator) {
	$('#PPPParametersForm').attr('target', '_self');
	$('#tmpDepositConfirmations').remove();
	app._popupWnd = false;
	pubsub.publish("popupWndClose", [{pmName: app.lastSelectedMethodType, initiator: initiator || 'popupCloseCallback'}]);
	if (app._flag.ommitPostSubmitCheck) {
		app._flag.ommitPostSubmitCheck = false;
		return;
	}
	if (app.config.session.isSessionExpired) {
		return;
	}
	app.getNextStepDo();
}

app.getNextStepDo = function () {
	var feRef = app.submittedMethod && app.submittedMethod.feRef || app._lastFeRef;
	pubsub.publish('app.event.getNextStepDoCalled', [{feRef: feRef}]);
	if (!app.util.FeRef.getRefData(feRef).getNextStepDoCalled) {
		app.util.FeRef.setRefData(feRef, "getNextStepDoCalled", 1);
	} else {
		return;
	}
	return $.ajax({
		url  : "getNextStep.do",
		data : {
			ssid      : app.ssid,
			CSRFToken : app.CSRFToken || $('input[name=CSRFToken]').val(),
			feRef     : feRef
		}
	}).done(function (data) {
		if (data) {
			if (data.status && data.status === "OK") {
				if (data['command'] === "go_away") {
					var exitIFrameElm = $('#exitIFrame');
					var url = '/ppp/forward.do?ssid=' + app.ssid + '&inPopupMode=false&inIframeMode=true' + '&CSRFToken=' + $('input[name="CSRFToken"]').val() + '&feRef='+ feRef;
					if (!exitIFrameElm.length) {
						app.bodyElm.append('<div style="display:none;"><iframe id="exitIFrame" src="' + url + '" scrolling="no" height="400" width="480" frameborder="0"></iframe></div>');
					} else {
						exitIFrameElm.attr('src', url);
					}
				} else if (data['command'] === "go_same_window") {
					window.location.href = '/ppp/forward.do?ssid=' + app.ssid + '&inPopupMode=false' + '&CSRFToken=' + $('input[name="CSRFToken"]').val() + '&feRef='+ feRef;
				} else if (data['command'] === "stay") {
					$.unblockUI();
					$("#continueButton").off().on("click", app.continueButtonHandler);
					if (data['userMessage'] != undefined && data['userMessage'] !== 'canceled') {
						data.feRef || (data.feRef = feRef);
						pubsub.publish('app.event.transactionComplete', [data]);
						if (!app.util.FeRef.getRefData(feRef).trxErrorReloadPMsCalled) {
							app.util.FeRef.setRefData(feRef, "trxErrorReloadPMsCalled", 1);
							app.reloadPMs();
						}
						if (app.quickDeposit.isShow) {
							var payload = {message: app.msg.payment_fail};
        					if(app.config.showTrxCompletePopups && data.reference) {
            					payload = {
                					details: {
										feRef: data.feRef || feRef,
                    					reference: data.reference,
										apmErrorMsg: app.msg.payment_fail
                					}
            					}
       					 	}
							app.util.handleTrxCompletePopups(payload, app.CONSTANTS.MODAL_MESSAGE_TYPE.ERROR);
						} else {
							var info = {feRef: feRef, isWS: false, source: 'getNextStepDo'};
							app.showErrorDeclineRecoveryPopup(data['userMessage'], null, data.reference, info);
						}
					} else {
						app.submittedMethod = false;
					}
				}
			} else {
				window.location.href = '/ppp/forward.do?ssid=' + app.ssid + '&inPopupMode=false' + '&CSRFToken=' + $('input[name="CSRFToken"]').val() + '&feRef='+ feRef;
			}
		}
	});
};

function waitPopupClose(popupWnd, closeCallback) {
	window.setTimeout(
		function () {
			if (popupWnd == undefined || popupWnd['closed'] == undefined || popupWnd['closed'] == true) {
				closeCallback();
			} else {
				waitPopupClose(popupWnd, closeCallback);
			}
		}, 200);
}

function _preRender(data) {
	// app.util.onPreRenderClearDOM();
}
function _postRender(pmData) {
	app.applyTooltipPlugin();
	app.util.addRemoveUpmButton(null, app.lastSelectedMethodId, app.lastSelectedMethodType);
	app.util.renderSaveUpoToggle(null, app.lastSelectedMethodId, app.lastSelectedMethodType);
	$('.PMINFO').removeClass(app.CONSTANTS.CARD_LOGO_CLASSES);

	_.each(_.keys(pmData), function (fldName) {
		var inputElm = $('#' + fldName);
		app.util.attachFieldValidation(fldName);
		if (inputElm.length) {
			if (inputElm[0].tagName === 'INPUT') {
				if (fldName.endsWith('cc_cvv2') && pmData[fldName] && pmData[fldName].type !== 'DISABLED') {
					inputElm.numberMask({type: 'number', beforePoint: 4, afterPoint: 0});
				}
				if (app.CONSTANTS.UPPER_CASE_FIELD_VALUE[fldName]) {
					inputElm.on("keyup", function () {
						var $this = $(this);
						$this.val($this.val().toUpperCase());
					});
				}
			}
		}
	});

	app.util.setDateValidation(pmData);
	if (app.config.isRebilling && app.config.rebillingTermsUrl) {
		app.util.renderRebillingTerms();
	}

	var _cardData = getCurrentCardType(null, true);
	app.util.updateDetectedCardBrand(_cardData.selectedBrand, _cardData.cardInfo, 'post_render')
	app.util.handleCardFields(pmData);

	var showAddNewCard = _.intersection(_.keys(app.pmLimits), ['visa', 'amex', 'master_card', 'diners_club_international', 'discover_card', 'jcb', 'laser', 'maestro', 'solo', 'switch']).length;
	if (!app.isMobile && showAddNewCard && app.config.showAddNewCardBtn) {
		$('.PMINFO .row:eq(1).readOnly').append('<span class="addPMIcon" title="Add another card" style="width:30px;height:30px;;float:left;margin-left:128px;background:url( resources/img/svg/ico_add.svg) no-repeat center center; cursor:pointer;"></span>');
		$('.addPMIcon').on('click', function () {
			pubsub.publish('dr-select-pm', [{uniqueId : 'cc_card', type : 'string'}]);
		});
	}

	app.applycSelectPlugin();
	app.applyOneRowDate();

	$('div.invalid_field').empty();

	if ($(".ob_bank_id-widget").length) {
		app.util.topBanksWidget.init();
	} else if (app.lastSelectedMethodType === app.CONSTANTS.PM_NAME.ABON) {
		$("#abon_voucherNumber").setMask("abon_voucherNumber");
	} else if (app.lastSelectedMethodType === app.CONSTANTS.PM_NAME.BLIK) {
		$("#blik_code").setMask({mask: '999 999'});
	} else if (app.lastSelectedMethodType === app.CONSTANTS.PM_NAME.PAYTO) {
		$("#payto_bsb").setMask({mask: '999-999'});
	} else if(app.lastSelectedMethodId === app.CONSTANTS.PM_NAME.MVP_NUVEI_CARD) {
		app.showModalMessage({message: ''}, 'mvp_nuvei_card');
		app.bodyElm.one('click', '[role="lbx_wrapper"] a.enter_card_detail, #lightbox a.enter_card_detail', function() {
			$('[role="lbx_wrapper"] .modal_close, #lightbox .modal_close').trigger('click');
			app.selectPM('cc_card');
		});
	}
	var dropDownValueDependentFields = app.CONSTANTS.DROPDOWN_VALUE_DEPENDENT_FIELDS[app.lastSelectedMethodType];
	_.each(dropDownValueDependentFields && Object.keys(dropDownValueDependentFields), function (fldName) {
		app.util.handleDropDownValueDependentFields(fldName, app.lastSelectedMethodType, app.lastSelectedMethodId);
	});

	if (app.util.c2p && _.isFunction(app.util.c2p.loadCardList)) {
		app.util.c2p.loadCardList();
	}

	app.util.onPMSelectedHandleBodyClasses(true);
}

function _renderCurrencies(currencyArr) {
	var $currencySelect = $('<select data-plugin="cSelect"></select>');
	$('#currency_lbl').empty().append($currencySelect);
	var lastSelectedCurrencyInList = false;
	var originalCurrencyInList = false;
	var selectedCurrency = app.lastSelectedCurrency;
	_.forEach(currencyArr, function (opt) {
		if (app.lastSelectedCurrency === opt.iso) {
			lastSelectedCurrencyInList = true;
		}
		if (app.currency === opt.iso) {
			originalCurrencyInList = true;
		}
		var option = $('<option/>');
		option.attr({'value' : opt.iso}).text(opt.name);
		if (opt.selected) {
			option.attr('selected', 'selected');
			selectedCurrency = opt.iso;
		}
		$currencySelect.append(option);
	});

	$currencySelect.cSelect();
	if (!lastSelectedCurrencyInList) {
		selectedCurrency = $currencySelect.val();
	}
	var onCurrencyChange = function (newCurrency) {
		var newSelectedCurrency = $(this).val() || newCurrency;
		var reloadTableData = {
			ssid               : app.ssid,
			newOpenAmountValue : $('#item_amount_1').val(),
			newCurrency        : newSelectedCurrency
		};
		var pmType = app.util.isUpo(app.lastSelectedMethodId) ? 'userPaymentOptionId' : 'paymentOptionName';
		reloadTableData[pmType] = app.lastSelectedMethodId;

		function onReloadTableResponse(data) { //lastSelectedCurrencyInList, newSelectedCurrency, originalCurrencyInList
			var isUpm = (!isNaN(parseInt(app.lastSelectedMethodId, 10))) ? true : 0;
			$('#currency_lbl span').remove();
			if (!lastSelectedCurrencyInList) {
				var label = ['<span style="width: 23rem;text-decoration: none; color: #F34C4C;">', _.escape(data['currency_changed_label']), '</span>'].join('');
				var currency_changed_tpl = $('#lbl_currency_changed');
				if (currency_changed_tpl.length) {
					label = $(_.template(currency_changed_tpl.text())());
				}
				$('#currency_lbl').append(label);
			}
			else if (newSelectedCurrency !== app.currency && originalCurrencyInList) {
				var revert_label = ['<span class="revert_currency">', _.escape(data['revert_label']), '</span>'].join('');
				var revert_currency_tpl = $('#lbl_revert_currency');
				if (revert_currency_tpl.length) {
					revert_label = $(_.template(revert_currency_tpl.text())());
				}
				$('#currency_lbl').append(revert_label);
				$('#currency_lbl .revert_currency').on('click', function () {
					app.lastSelectedCurrency = app.currency;
					$('#currency').val(app.lastSelectedCurrency);
					onCurrencyChange(app.currency);
				})
			}

			app.lastSelectedCurrency = newSelectedCurrency;
			app.lastSelectedAmount = data.item_amount_1;
			app.roundingScale = (data.hasOwnProperty("roundingScale") && !isNaN(parseInt(data.roundingScale))) ? parseInt(data.roundingScale) : app.roundingScale;
			app.util.setAmountValue(data.item_amount_1, []);
			$('#fixed_amount_1').val(data.item_amount_1);
			$('#currency').val(app.lastSelectedCurrency);
			$('#currency_lbl select').val(data.currency);
			$('#currency_lbl > .cSelect>div').text(data.currency);

			app.analytics.updateUSDExchangeRates(data.rate_to_usd);
			app.util.updateCurrencySelect(app.lastCardDetected); // TODO: check - lastCardDetected might be incorrect!?
			if (app.currentMethodFields && app.currentMethodFields.cc_card_number && $("#cc_card_number").val()) {
				app.util.validateField('cc_card_number', $("#cc_card_number").val(), null, null);
			}
			var amountLimits = {
				currencyISO : data.currency,
				minValue    : (app.isOpenAmount) ? data.item_min_amount_1 : data.item_amount_1,
				maxValue    : (app.isOpenAmount) ? data.item_max_amount_1 : data.item_amount_1
			};
			app.util.setPMAmountLimits(amountLimits);
			app.util.validateRoCardField('currencyChanged');
			pubsub.publish('app.event.currencyChanged', [{currencyISO: data.currency, amount: data.item_amount_1}]);

			if (app.config_getSrvFeesAndLimits) {
				app.util.getCustomLimitsAndFees(function (response) {
					if (response && app.util.assertAjaxResponseTypeJSON(response)) {
						if (response[app.CONSTANTS.SRV_RESPONSE.PROP_CUSTOM_FEES]) {
							app.current_pm_feeObj = response[app.CONSTANTS.SRV_RESPONSE.PROP_CUSTOM_FEES];
						} else {
							app.current_pm_feeObj = {};
						}
						app.pmLimits[app.lastSelectedMethodType].suggestedAmounts = [];
						app.pmLimits[app.lastSelectedMethodType].pricePoints = [];
						app.util.updatePMLimits(response['limits'], response['payment_method'], response['currency'], 'changeCurrency');
					}
					if (app.pmLimits[app.lastSelectedMethodType]) {
						app.applyRestrictions(app.pmLimits[app.lastSelectedMethodType]);
					}
					app.util.handleFee(app.current_pm_feeObj);
				});
			} else {
				/** prevent pmLimits.pricePoints & pmLimits.suggestedAmounts modification (since we can`t get them again) */
				var _limits = $.extend(true, {}, app.pmLimits[app.lastSelectedMethodType]);
				var $itemAmountElm = $('#item_amount_1');
				if ($itemAmountElm.length && $itemAmountElm[0].tagName === 'SELECT') {
					if (app.lastSelectedCurrency === app.currency) {
						/** default Currency => use default pricePoints */
						var dataObj = ((isUpm) ? app._upoList[app.lastSelectedMethodId] : app.pmLimits[app.lastSelectedMethodType]) || {};
						_limits.pricePoints = _.map(dataObj.pricePoints || [{
							active: true,
							currencyIso: app.lastSelectedCurrency,
							pointValue: data.item_amount_1
						}], function (item) {
							item.active = (item.pointValue == data.item_amount_1);
							return item;
						});
						_limits.suggestedAmounts = $.extend(true, [], dataObj['suggestedAmounts']);
					} else {
						_limits.pricePoints = [{
							active: true,
							pointValue: data.item_amount_1,
							currencyIso: app.lastSelectedCurrency
						}];
						_limits.suggestedAmounts = [];
					}
				}
				app.applyRestrictions(_limits, 'changeCurrency');
				$itemAmountElm.trigger('change'); //? do we need this
			}
		}

		if (app.config.useNewPLEndPoints) { // BACKLOG-1080:
			var cb = app.util.getChangeCurrencyCb(onReloadTableResponse);
			app.util.changeCurrency(cb, {action : "changeCurrency", newCurrency : newSelectedCurrency});
		} else { // old way:

			$.getJSON('reloadTable.do', reloadTableData, function (result) {
				if (app.config.isOpenAmount && result.products.length !== 1) {
					app.showFinalMessage("general_error_text");
					return;
				}
				var data = result.currencies;
				data.roundingScale = data.roundingScale != undefined ? data.roundingScale : result.products[0]["currencyRoundingScale"];
				/** ensure proper maxFractionLength */
				data.item_amount_1 = parseFloat(parseFloat(data.item_amount_1).toFixed(app.roundingScale));
				data.item_min_amount_1 = data.item_min_amount_1 != undefined ? data.item_min_amount_1 : result.products[0]["item_min_amount"];
				data.item_max_amount_1 = data.item_max_amount_1 != undefined ? data.item_max_amount_1 : result.products[0]["item_max_amount"];
				onReloadTableResponse(data);
			});
		}
	};
	onCurrencyChange(selectedCurrency);
	$currencySelect.on('change', onCurrencyChange);
}

app.renderCurrencyExchange = function (currencyArr, upoId) {
	var upoData = upoId && app._upoList[upoId];

	if (app.config.useDcc) {
		var dccData = app.util.prepareDccData(currencyArr);
		var preferredCurrency = app.config.userCurrency || app.lastSelectedCurrency;
		if (upoData && upoData.preferredCurrency && (dccData.obj.hasOwnProperty(upoData.preferredCurrency) || upoData.preferredCurrency === app.config.currency)) {
			preferredCurrency = upoData.preferredCurrency;
		}
		app.util.currencyExchange.renderDCC(dccData.arr, preferredCurrency, app.util.isCardPM(app.lastSelectedMethodType));
	} else {
		_renderCurrencies(currencyArr);
	}
	pubsub.publish('currencies-available', [currencyArr]);
};

app.applyRestrictions = function (data, initiator) {
	if (!app.isOpenAmount) {
		app.util.applyFixedAmountRestrictions();
		return;
	}

	app.lastSelectedAmount = $('#item_amount_1').val() || app.lastSelectedAmount;
	var amountLimits = (data && data['amountLimits'] && _.isObject(data['amountLimits'])) ? data['amountLimits'] : app.defaultLimits;
	var amountContainer = $('.amount-container');
	var hasPricePoints = (data && data['pricePoints'] && data['pricePoints'].length);
	var activeSuggestedIdx = (data && data['suggestedAmounts']) ? _.findIndex(data['suggestedAmounts'], 'active') : -1;
	var currency = app.ptRequestId ? app.currency : app.lastSelectedCurrency;
	var plainValues;
	var itemAmountElm;
	var suggestedValue = amountLimits.defaultAmount || app.lastSelectedAmount || app.amount;

	var regularCurrencyExchangeEnabled = (app.config.useCurrencyExchange && !app.config.ptRequestId && !app.config.useDcc);
	var usePtAmount = (initiator !== "changeCurrency" && app.config.ptAmount && !regularCurrencyExchangeEnabled);

	app.util.setMinMaxValidationLimits(amountLimits);
	app.util.setLabelOpenAmountRangeHeader(amountLimits, currency);
	app.util.clearFormAmountState();
	app.util.applySuggestPointsPlugin();

	if (hasPricePoints) {
		$('#label_open_amount_range').text(app.msg['pt_amount_header']);
		itemAmountElm = $('<select data-plugin="cSelect" id="item_amount_1" class="REQUIRED open_amount_input valid" name="item_amount_1"/>');
		var pricePoints = $.extend(true, [], data['pricePoints']);
		if (app.config.ptDoNotPrefillItemAmount) {
			pricePoints.unshift( { pointValue: '', pointText: app.msg['pt_amount_header'] } );
		}
		_.each(pricePoints, function (item) {
			var opt_txt = item['pointText'] !== undefined ? item['pointText'] : (app.config.useIntlFormatter ? app.formatter.formatCurrency(item['pointValue']) : item['pointValue']);
			$('<option/>', {value: item['pointValue'], text: opt_txt}).appendTo(itemAmountElm);
		});
		amountContainer.append(itemAmountElm);
		var activePricePointIdx = ( _.findIndex(pricePoints, 'active') >= 0 ) ? _.findIndex(pricePoints, 'active') : 0;

		if (usePtAmount && !app.config.ptDoNotPrefillItemAmount) {
			var ptAmountIndex = _.findIndex(pricePoints, {'pointValue' : parseFloat(parseFloat(app.config.ptAmount).toFixed(app.roundingScale))});
			activePricePointIdx = ptAmountIndex >= 0 ? ptAmountIndex : activePricePointIdx;
		}
		suggestedValue = pricePoints[activePricePointIdx]['pointValue'];

		plainValues = _.map(data['suggestedAmounts'], function (item) {
			return item['pointValue'] || 0;
		});
		if (app.suggestPointsPlugin) {
			app.suggestPointsPlugin.setData(plainValues || [], currency);
			app.suggestPointsPlugin.setValue(parseFloat(suggestedValue));
		}
		itemAmountElm.val(suggestedValue).trigger('change'); // 'change' because of cSelect
		app.applycSelectPlugin();
	}
	else {
		var amountContainerContent = app.util.getAmountElmTpl();
		amountContainer.append(amountContainerContent);
		itemAmountElm = amountContainer.find('#item_amount_1');
		plainValues = _.map(data['suggestedAmounts'], function (item) {
			return item['pointValue'] || 0;
		});
		if (app.suggestPointsPlugin) {
			app.suggestPointsPlugin.setData(plainValues || [], currency);
		}
		if (!app.config.ptDoNotPrefillItemAmount || initiator === "changeCurrency") {
			if (usePtAmount) {
				suggestedValue = parseFloat(parseFloat(app.config.ptAmount).toFixed(app.roundingScale));
				activeSuggestedIdx = _.indexOf(plainValues, suggestedValue);
				if (activeSuggestedIdx > -1 && app.suggestPointsPlugin) {
					suggestedValue = data['suggestedAmounts'][activeSuggestedIdx]['pointValue'];
					app.suggestPointsPlugin.setValue(suggestedValue);
				} else {
					app.util.setAmountValue(suggestedValue, []);
				}
			} else if (initiator !== "card_fld_change" && initiator !== "changeCurrency" && activeSuggestedIdx > -1 && app.suggestPointsPlugin) {
				/* overwrite  app.lastSelectedAmount to Active suggestedAmount Value ???!!!! */
				suggestedValue = data['suggestedAmounts'][activeSuggestedIdx]['pointValue'];
				app.suggestPointsPlugin.setValue(parseFloat(suggestedValue));
			} else {
				app.util.setAmountValue(suggestedValue, []);
				if (app.suggestPointsPlugin) {
					app.suggestPointsPlugin.setValue(parseFloat(suggestedValue));
				}
			}
		}
	}
	app.util.toggleSPointsClass(plainValues && plainValues.length, hasPricePoints);
	app.util.setAmountElmMinMaxLimits(amountLimits);
	app.lastSelectedAmount = suggestedValue;
	app.util.setAmountElmEvents(itemAmountElm);
	pubsub.publish('app.event.RestrictionsApplied', [app.lastSelectedAmount]);
};

app.getUPODetails = function (userPaymentOptionId, cb) {
	var def = new $.Deferred();
	var url = "selectUpo.do";
	$.ajax({
		url     : url,
		data    : {
			userPaymentOptionId : userPaymentOptionId,
			ssid                : app.ssid
		},
		success : cb,
		error   : cb
	}).done(function (resp) {
		var upoData = app.util.assertAjaxResponseTypeJSON(resp) && resp;
		def.resolve(upoData);
	}).fail(function () {
		def.resolve(false);
	});
	return def.promise();
};

app.prepareUpmViewData = function (data) {
	_.each(app.CONSTANTS.SPECIAL_FIELDS, function (field_name) {
		if (_.has(app._pmFields[app.lastSelectedMethodType], field_name) && !_.has(data, field_name)) {
			data[field_name] =  $.extend(true, {value : ''}, app._pmFields[app.lastSelectedMethodType][field_name]);
		}
	});
	var inputFieldsRaw = [];
	_.forIn(data, function (item) {
		/** ensure item is a field */
		if (_.isObject(item) && item.name) {
			inputFieldsRaw.push(item);
		}
	});
	var inputFields = _.map(inputFieldsRaw, function flatten(item) {
		var pmFieldObj = app._pmFields[app.lastSelectedMethodType] && app._pmFields[app.lastSelectedMethodType][item.name];
		var subObj = item['fieldRenderInfo'] || {};
		var fldLabel = (data[item.name] &&  data[item.name].label)
			|| (app.msg && app.msg[item.name])
			|| (pmFieldObj && pmFieldObj.label)
			|| '';

		return {
			name            : item.name,
			value           : item.value,
			type            : subObj['visibilityMode'] || item.type,
			uiOrder         : subObj.uiOrder,
			label           : fldLabel,
			dropDownOptions : (subObj.dropDownOptions || []),
			_hasRefId       : (data.hasReferenceId == "true")
		}
	});
	inputFields.sort(function (item1, item2) {
		return item1.uiOrder - item2.uiOrder;
	});
	_.each(inputFields, function cleanup(item) {
		delete item.uiOrder;
	});

	/***************  prepareUpmViewData helpers Start  *************/
	function _modify_cc_expire_data(inputFields) {
		var inputFieldsObj = {};
		_.each(inputFields, function (inputObj) {
			if (inputObj.name.endsWith('cc_exp_year') || inputObj.name.endsWith('cc_exp_month')) {
				if (!_.has(inputFieldsObj, 'expiration_period')) {
					inputFieldsObj['expiration_period'] = {};
				}
				inputFieldsObj['expiration_period'][inputObj.name] = inputObj;
			} else {
				inputFieldsObj[inputObj.name] = inputObj;
			}
		});
		return inputFieldsObj;
	}
	/***************  prepareUpmViewData helpers End  *************/

	return _modify_cc_expire_data(inputFields);
};

app.updateUIWithUpoData = function (data, selectedUserPaymentOptionId, rawUpoListItem) {
	if (data && data.status === "OK") {
		app.current_pm_feeObj = data.fee;
		var dataToSend = $.extend(true, {}, data, {'id' : selectedUserPaymentOptionId});
		_preRender(dataToSend);
		pubsub.publish('pre-upm-render', [dataToSend]);

		$('#userPaymentOptionId').val(selectedUserPaymentOptionId);

		var normalizedData = app.prepareUpmViewData(data);
		normalizedData['promoCode'] = {name : "promoCode", type : "OPTIONAL", label : app.msg.promo_code, value : ''};

		if(data.card_type || app.lastSelectedMethodType === 'visa_checkout'){
			normalizedData.card_type = data.card_type || '';
			normalizedData._cardData = {
				"cardBrand"			: data.cardBrand		|| rawUpoListItem.cardBrand,
				"cardBrand2"		: data.cardBrand2		|| rawUpoListItem.cardBrand2,
				"lastUsedBrand"		: data.lastUsedBrand	|| rawUpoListItem.lastUsedBrand,
				"isBrand1Allowed"	: data.isBrand1Allowed	!== undefined ? data.isBrand1Allowed : rawUpoListItem.isBrand1Allowed,
				"isBrand2Allowed"	: data.isBrand2Allowed	!== undefined ? data.isBrand2Allowed : rawUpoListItem.isBrand2Allowed,
				"isDualBrand"		: data.isDualBrand		!== undefined ? data.isDualBrand 	 : rawUpoListItem.isDualBrand
			};
			normalizedData.bin = data.bin || '';
			var regExCardPattern = /\((\d{4})\)|\d\*{4}(\d{4})|\d\*{3}\s+\*{4}\s+\*{4}\s+(\d{4})/;
			if (regExCardPattern.test(data.upoName)){
				normalizedData.last_4_digits = ((data.upoName).match(regExCardPattern)[1] || (data.upoName).match(regExCardPattern)[2] || (data.upoName).match(regExCardPattern)[3]);
				if(normalizedData.expiration_period) {
					normalizedData.expiration = { yy:data.cc_exp_year.value, mm:data.cc_exp_month.value};
				}
			}
		}

		var html = '';
		if (data && data.poStatus === 'SUSPENDED') {
			$('.is-suspended').addClass('hidden');
			html = app.util.getSuspendedPmHtml(dataToSend);
			app.util.addSuspendedPmBlocker(app.lastSelectedMethodId, !!html);
		} else if (data._extraData) {
			$('.is-suspended').removeClass('hidden');
			normalizedData._extraData = data._extraData;
			html = utils.getExtraDetailsHtml(data._extraData, data);
		} else {
			$('.is-suspended').removeClass('hidden');
			html = _getRegularUpoHtml(normalizedData, data);
		}

		$('.PMINFO').html(html);

		// wrong place! => _postRender
		if (app.config.canScanQR && app.lastSelectedMethodType === "apmgw_Abon") {
			app.util.scanDetails.init('scanQR');
		}
		app.util.handleFee(data.fee);
		app.currentMethodFields = app.util.fixExpPeriodFormat(normalizedData);
		data = app.util.doSomeUpmSpecificTask(data);
		app.util.renderOtherDetails(null, app.util.getOtherDetails());
		app.util.addDualBrandCardSelector(data, 'render_upm');
		app.util.handleBancontactOneClickCheckbox(data);
		_postRender(normalizedData);
		app.util.updateContinueButtonAction(null, data);
		app.util.setCVVLength(data);
		app.util.setCVVTooltip(data);
		utils.showDisableFieldValidationIcon(app.currentMethodFields, app.lastSelectedMethodType, false);

		pubsub.publish('post-upm-render', [dataToSend]);
	} else if (data.status === 'FAIL') {
		app.showFinalMessage(app.msg[data.message] || app.CONSTANTS.SRV_RESPONSE.MSG_SESSION_EXPIRED);
	}

	/***************  updateUIWithUpoData helpers Start  *************/

	function _getRegularUpoHtml(_normalizedData, _data) {
		var _html = '';
		var fld_maxlength = {
			echeck_account_number	: 12,
			echeck_aba_number		: 8,
			echeck_ssn				: 4,
			blik_code				: 6
		};
		_.each(srvPmFields, function (item) {
			var pm_prefix = '';
			var fldName = item.name;
			var normalizedDataPropertyName = item.name;

			if (fldName.endsWith('cc_exp_month')) {
				pm_prefix = fldName.substring(0, fldName.length - "cc_exp_month".length);
				normalizedDataPropertyName = 'expiration_period';
			}
			if (_.has(_normalizedData, normalizedDataPropertyName)) {
				if (normalizedDataPropertyName === 'expiration_period' && !_normalizedData['expiration_period'][fldName]) {
					return;
				}

				var fldObj = _normalizedData[normalizedDataPropertyName];
				fldObj.prefix = pm_prefix;
				fldObj.maxlength = fldObj.maxlength || (fld_maxlength[fldObj.name] || 70);
				if (fldName.endsWith('cc_card_number') && (fldObj.type === 'DISABLED' || fldObj.type === 'HIDDEN')) {
					fldObj.card_type = _normalizedData['card_type'];
				}
				if (fldObj.type === 'HIDDEN') {
					return;
				}

				var tplName = pm_prefix + normalizedDataPropertyName;
				var viewType = _getFldViewType(normalizedDataPropertyName, fldObj);
				var fldType = fldObj.dropDownOptions && fldObj.dropDownOptions.length ? 'select' : false;
				var payload = _.clone(fldObj);
				/** At that point, for fields other than the current one,
				 * some extra properties may be missing in the cloned normalizedData
				 * (eg. prefix, card_type, maxlength) - but currently we do not need them
				 * so we prefer to keep a good performance instead of ensuring their existence */
				payload.normalizedData = _.clone(_normalizedData);
				_html += app.util.getUpoFieldTemplate(tplName, viewType, fldType)(payload);
			}
		});
		return _html;
	}

	function _getFldViewType(_propertyName, _fldObj) {
		var type = (_fldObj.type !== 'DISABLED') ? 'rw' : 'ro';
		if (_propertyName === 'expiration_period') {
			var names = app.util.getDateFieldNames(_fldObj);
			var isExpirationPeriodRo = (names.expMonthId && (_fldObj[names.expMonthId].type === 'DISABLED' || _fldObj[names.expYearId].type === 'DISABLED'));
			if (isExpirationPeriodRo) {
				type = 'ro';
			}
		}
		return type;
	}

	/***************  updateUIWithUpoData helpers End  *************/
};

function unblockUI() {
	var exitFrameElm = $('#exitIFrame');
	if (exitFrameElm.length) {
		exitFrameElm.attr('src', 'blank.html');
	}
	$.unblockUI();
}

app.show3DIFrame = function (cfg) {
	cfg = cfg || {};
	_.each(['iframeMaxHeight','iframeWidth'], function(key){
		if(cfg.hasOwnProperty(key) && cfg[key]){
			cfg[key] = app.util.normalizePixelValue(cfg[key]);
		}
	});
	var iframeElm = $('#targetIFrame');
	var iframeDivElm = iframeElm.parent();
	var iframeDivElmWidth;
	var iframeDivElmHeight;
	var iframeDivElmMaxHeight;
	var iframeDivElmMaxWidth;

	var isMobile = {
		iOS : function () {
			return navigator.userAgent.match(/iPhone|iPad|iPod/i);
		}
	};
	var iOSMargin = app.util.normalizePixelValue(75);
	var widthPercentage = 98;

	var setIFramePosition = function (wrapper) {
		iframeDivElmMaxHeight = Math.round(isMobile.iOS() ? viewportSize.getHeight() - iOSMargin : viewportSize.getHeight());
		iframeDivElmMaxWidth = Math.round((viewportSize.getWidth() * widthPercentage ) / 100);
		$(wrapper).css({
			'max-height' : iframeDivElmMaxHeight,
			'width'      : ((cfg.iframeWidth && cfg.iframeWidth <= iframeDivElmMaxWidth) ? cfg.iframeWidth : iframeDivElmMaxWidth)
		});
		var iframeInfoHeight = $('#iframe_info', wrapper).outerHeight() || 0;
		iframeDivElmWidth = $(wrapper).outerWidth();
		iframeDivElmHeight = $(wrapper).outerHeight();

		if (cfg.iframeMaxHeight && (cfg.iframeMaxHeight + iframeInfoHeight) <= iframeDivElmMaxHeight) {
			iframeDivElmHeight = (cfg.iframeMaxHeight + iframeInfoHeight);
		}
		if (iframeDivElmMaxHeight - 10 > iframeDivElmHeight) {
			iframeDivElmHeight = cfg.iframeMaxHeight && Math.min(iframeDivElmMaxHeight - 10, cfg.iframeMaxHeight) || (iframeDivElmMaxHeight - 10);
		}

		$(wrapper).css({
			'height'      : iframeDivElmHeight,
			'margin-top'  : -iframeDivElmHeight / 2,
			'margin-left' : -iframeDivElmWidth / 2
		});
		iframeElm.css({
			'max-height' : (iframeDivElmHeight - iframeInfoHeight - 4)
		});
	};

	iframeElm.css({
		'max-height' : (cfg.iframeMaxHeight || $(iframeDivElm).outerHeight())
	});
	setIFramePosition(iframeDivElm);

	if (!app.modalLink_2) {
		app.modalLink_2 = $('<a href="#targetIframeWrap"></a>');
		app.modalLink_2.sModal({
			closeButton : ".btn",
			onClose     : app.util.closeTargetIframe
		});
	}
	app.modalLink_2.trigger('click');
	setIFramePosition(iframeDivElm);
	if (!app._flag.tree_d_iframe_resize_event) {
		$(window).on('resize', function () {
			setIFramePosition(iframeDivElm);
		});
		app._flag.tree_d_iframe_resize_event = 1;
	}
};

app.showErrorDeclineRecoveryPopup = function (error, apmErrorMsg, trxRef, info) {
	info || (info = {});
	app.util.FeRef.isValid(info.feRef) || (info.feRef = app._lastFeRef);
	var refData = app.util.FeRef.getRefData(info.feRef);
	info.submittedMethod = refData.submittedMethod;
	info.isOldFeRef = info.feRef !== app._lastFeRef;
	var modalWrapper = info.isWS ? "lightbox_ws" : null;
	var title = null;
	if (app.config.useCsmsMessages) {
		info.showPmInfo = true;
		app.msg.lightbox_error_suggest = app.msg.lightbox_error_suggest_csms;
		if (!refData.csmsCallDone) {
			app.util.FeRef.setRefData(info.feRef, "csmsCallDone", 1);
			$.getJSON("getCsmsMessages.do", {ssid: app.ssid, feRef: info.feRef})
				.done(_onCsmsResponse)
				.error(function (err) {
					app.util.onDeclineRecoveryMessage([], error, apmErrorMsg, null, trxRef, modalWrapper, title, info);
				});
		} else { // we know the csms result => should skip next popup
			var obj =  {ts: Date.now(), isWS: info.isWS, error: error, trxRef: trxRef, apmErrorMsg: apmErrorMsg};
			app.util.FeRef.setRefData(info.feRef, "skipMsg", obj);
			$.unblockUI();
		}
	} else if (app.config.useDeclineRecovery && !refData.isOldFeRef ) {
		info.showPmInfo = false;
		$.getJSON("getDeclineRecoveryMessages.do", {ssid: app.ssid, feRef: info.feRef})
			.done(function (data) {
				app.util.FeRef.setRefData(info.feRef, "drResp", data);
				app.util.onDeclineRecoveryMessage(data, error, apmErrorMsg, null, trxRef, modalWrapper, title, info);
			});
	} else {
		info.showPmInfo = false;
		app.util.onDeclineRecoveryMessage([], error, apmErrorMsg, null, trxRef, modalWrapper, title, info);
	}

	/***************  showErrorDeclineRecoveryPopup helpers Start  *************/
	function _onCsmsResponse(data) {
		var drData;
		app.util.FeRef.setRefData(info.feRef, "csmsResp", data);
		if (!_.isEmpty(data)) {
			drData = !info.isOldFeRef && app.util.convertCsmsDeclineRecoveryData(data);
			title = data.rule && data.rule.ruleMessageTitle;
			data.rule && data.rule.ruleMessageBody && (apmErrorMsg = data.rule.ruleMessageBody);
		}
		app.util.onDeclineRecoveryMessage(drData, error, apmErrorMsg, null, trxRef, modalWrapper, title, info);
	}
	/***************  showErrorDeclineRecoveryPopup helpers End  *************/
};

window.applePay = (function () {
	var applePayObj = {
		submitFormWithApplePayToken : function (json) {
			//$('.logo').text('submitFormWithApplePayToken called' + json);
			//document.location.href = 'http://apple.pay.capture.me.invaliddomain/success';
			if (!$('#applePayJson').length) {
				$('.PMINFO').append('<input type="hidden" id="applePayJson" name="applePayJson" value="">');
			}

			var paymentMethodData = json && json.paymentMethod || {};
			var brand = (paymentMethodData.network || '').toLowerCase();
			if (brand === "mastercard") {
			    brand = "master_card";
			}
			app.util.updateDetectedCardBrand(brand, null, "applePayAuthorization");
			var pubsub_payload = {
			    cardBrand: brand,
			    cardNetwork: paymentMethodData.network,
			    displayName: paymentMethodData.displayName
			}
			pubsub.publish('applepay.paymentAuthorized.info', [pubsub_payload]);

			$('#applePayJson').val(JSON.stringify(json));
			$('#inIframeMode').val('true');
			$('#inPopupMode').val('false');
			if (app.config.isRebilling) {
				app.sub.doSubscribe();
			} else {
				submitInIframe();
			}
		},
		onCancel                    : function () {
			$.unblockUI();
			$('#continueButton').off().one("click", app.util.handleApplePay);
			pubsub.publish('apple_session.canceled', []);
		}
	};
	return applePayObj;
}());